import { CaseFilter } from 'src/pages/Cases/constants/CasesConstants';
import { IClickStreamEvent } from './clickStream.type';

export const prefixUrl = 'https://';
export const janusServiceUrl = '/events/json';

const CLICKSTREAM_GLOBAL_ATTRIBUTES = Object.freeze({
  SOURCE: 'source',
  TIMESTAMP: 'timestamp',
  AGENT_ID: 'agent_id',
  CUSTOMER_ID: 'customer_id',
  TAB_ID: 'tab_id',
  ATTTIBUTES: 'attributes',
  EVENT_NAME: 'event_name',

  // event based data
  DESCRIPTION: 'description',
  PHONE_NUMBER: 'phone_number',
  SUCESS_CALL: 'sucess',
  OTP: 'otp',
  NUMBER_OF_CASES: 'number_of_cases',
  PAGE_NUMBER: 'page_number',
  EMI_NUMBER: 'emi_number',
  EMI_PAID: 'emi_paid',
  TRANSACTION_DATE: 'transaction_date',
  PAYMENT_REF: 'payment_ref',
  NEW_PHONE_NUMBER: 'new_phone_number',
  DOCUMENT_TYPE: 'document_type',
  DATE_TIME: 'date_time',
  PAGE_LOAD_TIME: 'page_load_time',
  NOTIFICATION_TYPE: 'notification_type',
  NOTIFICATION_TEMPLTE: 'notification_template',
  INTERACTION_TYPE: 'interaction_type',
  FEEDBACK_COMMENT: 'feedback_comment',
  PAYMENT_LINK: 'payment_link',
  INTEREST_AMOUNT: 'interest_amount',
  DROPDOWN_NAME: 'dropdown_name',
  CURRENT_CUSTOMER_ID: 'current_customer_id',
  NEXT_CUSTOMER_ID: 'next_customer_id',
  ENTERED_DATE: 'entered_date'
});

export const CLICKSTREAM_EVENT_NAMES = Object.freeze({
  SEND_EXTENSION_VERSION: {
    name: 'SEND_EXTENSION_VERSION',
    description: 'send extension version to clickstream'
  },
  LH_POST_OPERATIVE_HOURS_SCREEN_LOADED: {
    name: 'FA_POST_OPERATIVE_HOURS_SCREEN_LOADED',
    description: 'Post operative hours screen loaded'
  },

  // login screen
  LH_Login_PhnVerifyCTA: 'LH_Login_PhnVerifyCTA',
  LH_Login_OTPVerifyCTA: 'LH_Login_OTPVerifyCTA',
  LH_Login_GoogleCTA: { name: 'LH_Login_GoogleCTA', description: 'Login With Google CTA' },
  // Dashboard screen
  LH_Dashboard_PageLand: {
    name: 'LH_Dashboard_PageLand',
    description: 'User Lands on Dashboard page'
  },
  LH_Dashboard_SidePanelIconClick: {
    name: 'LH_Dashboard_SidePanelIconClick',
    description: 'Click on Dashboard option on Side Panel'
  },
  LH_REALLOCATION_SIDE_PANEL_CLICK: {
    name: 'LH_REALLOCATION_SIDE_PANEL_CLICK',
    description: 'Click on Reallocation option on Side Panel'
  },
  LH_ALL_AGENTS_SIDE_PANEL_CLICK: {
    name: 'LH_ALL_AGENTS_SIDE_PANEL_CLICK',
    description: 'Click on All Agents Icon on Side Panel'
  },
  LH_ALLOCATION_SIDE_PANEL_CLICK: {
    name: 'LH_ALLOCATION_SIDE_PANEL_CLICK',
    description: 'Click on Allocation Icon on Side Panel'
  },

  LH_WHATSAPP_CHATBOT_CLICK: {
    name: 'LH_WHATSAPP_CHATBOT_CLICK',
    description: 'Click on Whatsapp Chatbot option on Side Panel'
  },
  LH_PERFORMANCE_Dashboard_SidePanelIconClick: {
    name: 'LH_PERFORMANCE_Dashboard_SidePanelIconClick',
    description: 'Click on Performance Dashboard option on Side Panel'
  },
  LH_ID_CARDS_PAGE_CLICKED: {
    name: 'LH_ID_CARDS_PAGE_CLICKED',
    description: 'Click on ID card approval option on Side Panel'
  },
  LH_AMEYO_UTILITY_PAGE_CLICKED: {
    name: 'LH_AMEYO_UTILITY_PAGE_CLICKED',
    description: 'Click on Ameyo Utility option on Side Panel'
  },
  LH_TL_GENERATE_AMEYO_PASSWORD_SidePanelIconClick: {
    name: 'LH_TL_GENERATE_AMEYO_PASSWORD_SidePanelIconClick',
    description: 'Click on TL Generate ameyo password option on Side Panel'
  },
  LH_LEAVE_MANAGEMENT_PAGE_CLICKED: {
    name: 'LH_LEAVE_MANAGEMENT_PAGE_CLICKED',
    description: 'Click on leave management option on Side Panel'
  },
  LH_CaseList_SidePanelIconClick: {
    name: 'LH_CaseList_SidePanelIconClick',
    description: 'Click on Case list icon on Side Panel'
  },
  LH_CaseList_AgencyPincodeIconClick: {
    name: 'LH_agencyPinCode_SidePanelIconClick',
    description: 'Click on agency pincode mapping icon on Side Panel'
  },
  LH_CsaCoordination_SidePanelIconClick: {
    name: 'LH_CsaCoordination_SidePanelIconClick',
    description: 'Click on Csa Coordination option on Side Panel'
  },
  LH_ANOMALY_TRACKER_SIDE_PANEL_CLICK: {
    name: 'LH_ANOMALY_TRACKER_SIDE_PANEL_CLICK',
    description: 'Click on Anomaly Tracker option on Side Panel'
  },
  LH_FIELD_SUPPORT_SIDE_PANEL_CLICK: {
    name: 'LH_FIELD_SUPPORT_SIDE_PANEL_CLICK',
    description: 'Click on Field Support option on Side Panel'
  },
  LH_AGENCY_MANAGEMENT_SIDE_PANEL_CLICK: {
    name: 'LH_AGENCY_MANAGEMENT_SIDE_PANEL_CLICK',
    description: 'Click on Agency Management option on Side Panel'
  },
  LH_PARAMOUNT_SIDE_PANEL_CLICK: {
    name: 'LH_PARAMOUNT_SIDE_PANEL_CLICK',
    description: 'Click on Paramount option on Side Panel'
  },
  LH_STATE_RESETTER_SIDE_PANEL_CLICK: {
    name: 'LH_STATE_RESETTER_SIDE_PANEL_CLICK',
    description: 'Click on State Resetter option on Side Panel'
  },
  LH_REPORTS_SIDE_PANEL_CLICK: {
    name: 'LH_REPORTS_SIDE_PANEL_CLICK',
    description: 'Click on Reports option on Side Panel'
  },
  LH_CASES_SIDE_PANEL_CLICK: {
    name: 'LH_CASES_SIDE_PANEL_CLICK',
    description: 'Click on Cases option on Side Panel'
  },
  LH_CALLING_AGENT_DASHBOARD_SIDE_PANEL_CLICK: {
    name: 'LH_CALLING_AGENT_DASHBOARD_SIDE_PANEL_CLICK',
    description: 'Click on Calling Agent Dashboard option on Side Panel'
  },
  LH_CSA_DASHBOARD_SIDE_PANEL_CLICK: {
    name: 'LH_CSA_DASHBOARD_SIDE_PANEL_CLICK',
    description: 'Click on CSA Dashboard option on Side Panel'
  },
  LH_AGENT_SENSEI_DASHBOARD_SIDE_PANEL_CLICK: {
    name: 'LH_AGENT_SENSEI_DASHBOARD_SIDE_PANEL_CLICK',
    description: 'Click on Agent Sensei Dashboard option on Side Panel'
  },
  LH_FDM_SENSEI_DASHBOARD_SIDE_PANEL_CLICK: {
    name: 'LH_FDM_SENSEI_DASHBOARD_SIDE_PANEL_CLICK',
    description: 'Click on FDM Sensei Dashboard option on Side Panel'
  },
  // all cases
  LH_CaseList_PageLand: {
    name: 'LH_CaseList_PageLand',
    description: 'User lands on Case List page '
  },
  LH_CaseList_CustomerClick: {
    name: 'LH_CaseList_CustomerClick',
    description: 'Click on the Collection case record/row'
  },
  LH_Cases_FilterClick: 'LH_Cases_FilterClick',
  LH_Cases_SortClick: 'LH_Cases_SortClick',
  LH_CaseList_SortSuccess: {
    name: 'LH_CaseList_SortSuccess',
    description: 'Click on sort and display results'
  },
  LH_CaseList_SearchSuccess: {
    name: 'LH_CaseList_SearchSuccess',
    description: 'Search results are displayed'
  },
  LH_CaseList_FilterSuccess: {
    name: 'LH_CaseList_FilterSuccess',
    description: 'Filtered are applied'
  },
  LH_CaseList_PaginationClick: {
    name: 'LH_CaseList_PaginationClick',
    description: 'Click on Pages/Arrows on Pagination '
  },
  // Easy case navigation
  LH_CaseDetails_NavigationClick: {
    name: 'LH_CaseDetails_NavigationClick',
    description: 'Click on Next/Prev navigation button'
  },
  LH_CaseDetails_BackButtonClick: {
    name: 'LH_CaseDetails_BackButtonClick',
    description: 'Click on Back button on top left hand corner'
  },
  //case details overview tab
  LH_Overview_PageLand: {
    name: 'LH_Overview_PageLand',
    description: 'Lands on the Overview Page'
  },
  LH_Overview_AlertBanner: {
    name: 'LH_Overview_AlertBanner',
    description: 'LClicks on the Arrows of the Alert banners'
  },
  // case details loan details tab
  LH_LoanDetails_PageLand: {
    name: 'LH_LoanDetails_PageLand',
    description: 'User lands on Loan Details page'
  },
  // summary tab
  LH_Summary_PageLand: 'LH_Summary_PageLand',
  LH_Summary_PrevPTPClick: 'LH_Summary_PrevPTPClick',
  LH_Summary_FeedbackPagination: 'LH_Summary_FeedbackPagination',
  LH_Summary_PaymentPagination: 'LH_Summary_PaymentPagination',
  LH_Summary_EnachClick: 'LH_Summary_EnachClick',
  LH_BottomNavigation_Click: 'LH_BottomNavigation_Click',
  LH_Summary_PaymentScroll: 'LH_Summary_PaymentScroll',
  LH_Summary_FeedbackScroll: 'LH_Summary_FeedbackScroll',
  // loan details tab
  LH_LoanDetails_TabClick: 'LH_LoanDetails_TabClick',
  LH_LoanDetails_EnachSetupETA: 'LH_LoanDetails_EnachSetupETA',
  // EMI SHedule Tab
  LH_EMISchedule_PageLand: {
    name: 'LH_EMISchedule_PageLand',
    description: 'User lands on EMI Schedule page'
  },
  LH_EMISchedule_DueDropdown: {
    name: 'LH_EMISchedule_DueDropdown',
    description: 'Click on Due Dropdown'
  },
  LH_EMISchedule_PaymentHistory: {
    name: 'LH_EMISchedule_PaymentHistory',
    description: 'Click on payment history of due '
  },
  LH_EMISchedule_CalculateInterest: 'LH_EMISchedule_CalculateInterest',
  LH_EMISchedule_CalculateCTA: 'LH_EMISchedule_CalculateCTA',
  LH_EMISchedule_PayHistIcon: 'LH_EMISchedule_PayHistIcon',
  LH_EMISchedule_FeeWaiveIcon: 'LH_EMISchedule_FeeWaiveIcon',
  LH_EMISchedule_WaiveFeeCTA: {
    name: 'LH_EMISchedule_WaiveFeeCTA',
    description: 'Click on Fee Waive CTA'
  },
  LH_EMISchedule_WaiveCrossClick: {
    name: 'LH_EMISchedule_WaiveCrossClick',
    description: 'Click on Waive Cross / Outside'
  },
  LH_EMISchedule_WaiveSubmit: {
    name: 'LH_EMISchedule_WaiveSubmit',
    description: 'Click on Waive Submit'
  },
  LH_EMISchedule_QuickFilter: {
    name: 'LH_EMISchedule_QuickFilter',
    description: 'Click on Quick Filter'
  },
  LH_EMISchedule_CalculateOverdue: {
    name: 'LH_EMISchedule_CalculateOverdue',
    description: 'Click on Calculate Overdue'
  },
  LH_EMISchedule_AutoPayHistory: {
    name: 'LH_EMISchedule_AutoPayHistory',
    description: 'Click on Auto Pay History'
  },
  LH_EMISchedule_FeeWaiverHistory: {
    name: 'EMISchedule_FeeWaiverHistory',
    description: 'Click on Fee waiver History'
  },
  LH_EMISchedule_CalculateOverdueCTA: 'LH_EMISchedule_CalculateOverdueCTA',
  LH_EMISchedule_EndScroll: 'LH_EMISchedule_EndScroll',
  // Repayments tab
  LH_Repayments_PageLand: {
    name: 'LH_Repayments_PageLand',
    description: 'User lands on Repayments page'
  },
  LH_Repayments_PaginationClick: {
    name: 'LH_Repayments_PaginationClick',
    description: 'Click on Pages/Arrows on Pagination of repayments'
  },
  LH_Repayments_ShareEnachLinkCTA: 'LH_Repayments_ShareEnachLinkCTA',
  LH_Repayments_DropDown: 'LH_Repayments_DropDown',
  // Phone number tab
  LH_Phone_PageLand: {
    name: 'LH_Phone_PageLand',
    description: 'User lands on Phone Number page'
  },
  LH_PhoneNo_CallIcon: 'LH_PhoneNo_CallIcon',
  LH_Phone_AddNewNumberCTA: {
    name: 'LH_Phone_AddNewNumberCTA',
    description: 'Click on Add New Number CTA'
  },
  LH_Phone_AddNewNumberSubmit: {
    name: 'LH_Phone_AddNewNumberSubmit',
    description: 'Click on Add New Number submit button'
  },
  LH_Phone_AddNewNumberCross: {
    name: 'LH_Phone_AddNewNumberCross',
    description: 'Click on cross button of the add new number modal'
  },
  LH_PhoneNo_AddCTA: 'LH_PhoneNo_AddCTA',
  LH_Email_PageLand: {
    name: 'LH_Email_PageLand',
    description: 'User lands on Email page'
  },
  LH_Email_AddNewEmailCTA: {
    name: 'LH_Email_AddNewEmailCTA',
    description: 'Click on Add New Email CTA'
  },
  LH_Email_AddNewEmailCross: {
    name: 'LH_Email_AddNewEmailCross',
    description: 'Click on cross button of the add new email modal'
  },
  LH_Email_AddNewEmailSubmit: {
    name: 'LH_Email_AddNewEmailSubmit',
    description: 'Click on Add New Email submit button'
  },
  // Documents tab
  LH_Documents_PageLand: {
    name: 'LH_Documents_PageLand',
    description: 'User lands on Documents page'
  },
  LH_Documents_PhotoClick: {
    name: 'LH_Documents_PhotoClick',
    description: 'Click on Document Photo'
  },
  LH_Documents_DropDown: 'LH_Documents_DropDown ',
  LH_Documents_VKYCActions: {
    name: 'LH_Documents_VKYCActions',
    description: 'Click on VKYC Actions'
  },
  LH_PII_ACKNOWLEDGMENT_MODAL_SHOWN: {
    name: 'LH_PII_ACKNOWLEDGMENT_MODAL_SHOWN',
    description: 'PII acknowledgment modal shown'
  },
  LH_PII_REVOKED_MODAL_SHOWN: {
    name: 'LH_PII_REVOKED_MODAL_SHOWN',
    description: 'PII revoke modal shown'
  },
  LH_PII_ACKNOWLEDGMENT_SUBMITTED: {
    name: 'LH_PII_ACKNOWLEDGMENT_SUBMITTED',
    description: 'PII acknowledgment submitted'
  },
  LH_PII_ACKNOWLEDGMENT_CANCELLED: {
    name: 'LH_PII_ACKNOWLEDGMENT_CANCELLED',
    description: 'PII acknowledgment cancelled'
  },
  // address tab
  LH_Addresses_PageLand: {
    name: 'LH_Addresses_PageLand',
    description: 'User lands on Address page'
  },
  LH_Addresses_ViewOtherCTA: {
    name: 'LH_Addresses_ViewOtherCTA',
    description: 'User clicks on view other CTA'
  },
  // interactions tab
  LH_Interactions_PageLand: {
    name: 'LH_Interactions_PageLand',
    description: 'User lands on Interactions tab'
  },
  LH_Interactions_CallFeedbackPageLand: {
    name: 'LH_Interactions_CallFeedbackPageLand',
    description: 'User lands on Call Interactions page'
  },
  LH_Field_Interactions_CallFeedbackPageLand: {
    name: 'LH_Field_Interactions_CallFeedbackPageLand',
    description: 'User lands on Field Call Interactions page'
  },
  LH_Interactions_FieldFeedbackPageLand: {
    name: 'LH_Interactions_FieldFeedbackPageLand',
    description: 'User lands on Field Interactions page'
  },
  LH_Interactions_NaviWAPageLand: {
    name: 'LH_Interactions_NaviWAPageLand',
    description: 'User lands on Navi Whatsapp Interactions page'
  },
  LH_Interactions_EscalationPageLand: {
    name: 'LH_Interactions_EscalationPageLand',
    description: 'User lands on Navi escalation Interactions page'
  },
  LH_Interactions_SMSPageLand: {
    name: 'Interactions_SMSPageLand',
    description: 'User lands on SMS Interactions page'
  },
  LH_Interactions_WAPageLand: {
    name: 'LH_Interactions_WAPageLand',
    description: 'User lands on whatsapp Interactions page'
  },
  LH_Interactions_IVRPageLand: {
    name: 'LH_Interactions_IVRPageLand',
    description: 'User lands on IVR Interactions page'
  },
  LH_Interactions_EmailPageLand: {
    name: 'LH_Interactions_EmailPageLand',
    description: 'User lands on Email Interactions page'
  },
  LH_Interactions_PNPageLand: {
    name: 'LH_Interactions_PNPageLand',
    description: 'User lands on Push Notifications Interactions page'
  },
  LH_Interactions_DunningLetter: {
    name: 'LH_Interactions_DunningLetter',
    description: 'Click on DunningLetter download button'
  },
  LH_Interactions_LegalLetter: {
    name: 'LH_Interactions_LegalLetter',
    description: 'Click on LegalLetter download button'
  },
  LH_Interactions_PaginationClick: {
    name: 'LH_Interactions_PaginationClick',
    description: 'Click on Pagination of interactions table'
  },
  LH_Interactions_OnlyContactableToggle: {
    name: 'LH_Interactions_OnlyContactableToggle',
    description: 'Click on only contactable toggle of interactions table'
  },
  LH_Interactions_FromDateIcon: {
    name: 'LH_Interactions_FromDateIcon',
    description: 'Click on From Date Icon'
  },
  LH_Interactions_ToDateIcon: {
    name: 'LH_Interactions_ToDateIcon',
    description: 'Click on To Date Icon'
  },
  LH_Interactions_CallsViewCTA: {
    name: 'LH_Interactions_CallsViewCTA',
    description: 'Click on view feedback button'
  },
  LH_Interactions_CallsAddCTA: {
    name: 'LH_Interactions_CallsAddCTA',
    description: 'Click on add feedback button'
  },
  LH_Interactions_AddFeedbackSubmit: {
    name: 'LH_Interactions_AddFeedbackSubmit',
    description: 'Click on add feedback submit button'
  },
  // notification
  LH_Notifications_BellIconClick: {
    name: 'LH_Notifications_BellIconClick',
    description: 'Click on bell icon'
  },
  LH_Notifications_TabsClick: {
    name: 'LH_Notifications_TabsClick',
    description: 'Click on bell icon'
  },
  LH_Notifications_ShowUnreadToggle: {
    name: 'LH_Notifications_ShowUnreadToggle',
    description: 'Toggle on "Show only unread" option'
  },
  LH_Notifications_IndividualNotifClick: {
    name: 'LH_Notifications_IndividualNotifClick',
    description: 'Click on any of the notifications'
  },
  LH_Notifications_Exit: {
    name: 'LH_Notifications_Exit',
    description: 'close notifications drawer'
  },
  Notifications_CallCTA: {
    name: 'Notifications_CallCTA',
    description: 'click on call CTA'
  },
  Notifications_ViewEMIsCTA: {
    name: 'Notifications_ViewEMIsCTA',
    description: 'click on View EMIs CTA'
  },
  LH_Notifications_NOTIFICATION_RECEIVED: {
    name: 'LH_Notifications_NOTIFICATION_RECEIVED',
    description: 'FCM notification received'
  },
  // logo click
  LH_NaviLogo_Click: 'LH_NaviLogo_Click',
  // hamburger icon
  LH_Hamburger_IconClick: 'LH_Hamburger_IconClick',
  LH_Hamburger_LogoutCTA: 'LH_Hamburger_LogoutCTA',
  LH_Hamburger_CrossIconClick: 'LH_Hamburger_CrossIconClick',
  // feedback side tab
  LH_Feedback_TabClick: 'LH_Feedback_TabClick',
  LH_Feedback_PageLand: 'LH_Feedback_PageLand',
  LH_Feedback_OpenSlashClick: 'LH_Feedback_OpenSlashClick',
  LH_Feedback_CallGSM: 'LH_Feedback_CallGSM',
  LH_Feedback_CallLandline: 'LH_Feedback_CallLandline',
  LH_Feedback_InteractionStatusClick: 'LH_Feedback_InteractionStatusClick',
  LH_Feedback_SubmitCTA: 'LH_Feedback_SubmitCTA',
  LH_Feedback_DispositionCross: 'LH_Feedback_DispositionCross',
  LH_Feedback_CallCTA: {
    name: 'LH_Feedback_CallCTA',
    description: 'Click on Call CTA'
  },
  LH_Feedback_PhoneNumberDropdown: {
    name: 'LH_Feedback_PhoneNumberDropdown',
    description: 'select phone number from dropdown'
  },
  LH_Feedback_OpenSlashCTA: {
    name: 'LH_Feedback_OpenSlashCTA',
    description: 'click on open slash button'
  },
  LH_Feedback_CallTypeChipSelect: {
    name: 'LH_Feedback_CallTypeChipSelect',
    description: 'click on call type chips'
  },
  LH_Feedback_CustomerFeedback: {
    name: 'LH_Feedback_CustomerFeedback',
    description: 'click on customer feedback'
  },
  LH_Feedback_SubmitFeedback: {
    name: 'LH_Feedback_SubmitFeedback',
    description: 'click on submit feedback'
  },
  // payment side tab
  LH_Payments_CopyPaymentLink: {
    name: 'LH_Payments_CopyPaymentLink',
    description: 'click on copy payment link'
  },
  LH_Payments_SharePaymentLink: {
    name: 'LH_Payments_SharePaymentLink',
    description: 'click on share payment link'
  },
  LH_Payments_CopyForeclosureLink: {
    name: 'LH_Payments_CopyForeclosureLink',
    description: 'click on copy foreclosure link'
  },
  LH_Payment_TabClick: 'LH_Payment_TabClick',
  LH_Payment_PageLand: 'LH_Payment_PageLand',
  LH_Payment_SendPaymentCTA: 'LH_Payment_SendPaymentCTA',
  LH_Payment_CopyPaymentCTA: 'LH_Payment_CopyPaymentCTA',
  LH_Repayments_EndScroll: 'LH_Repayments_EndScroll',
  //leaderboard
  LH_PerfLevel_DropdownClick: {
    name: 'LH_PerfLevel_DropdownClick',
    description: 'Click on drop down on performance level banner'
  },
  LH_Dashboard_CalenderMonthCashCollected: {
    name: 'LH_Dashboard_CalenderMonthCashCollected',
    description: 'Click on different months on Cash Collection'
  },
  LH_Dashboard_QuickFilterCashCollected: {
    name: 'LH_Dashboard_QuickFilterCashCollected',
    description: 'Click on Quick filter view of Cash Collected'
  },
  LH_Dashboard_QuickFilterPerformanceLevel: {
    name: 'LH_Dashboard_QuickFilterPerformanceLevel',
    description: 'Click on Quick filter view of Performance level'
  },
  LH_TEAM_LEAD_DASHBOARD_SidePanelIconClick: {
    name: 'LH_TEAM_LEAD_DASHBOARD_SidePanelIconClick',
    description: 'Click on TEAM_LEAD Dashboard option on Side Panel'
  },
  LH_GENERATE_AMEYO_PASSWORD_SidePanelIconClick: {
    name: 'LH_GENERATE_AMEYO_PASSWORD_SidePanelIconClick',
    description: 'Click on Generate ameyo password option on Side Panel'
  },
  LH_COSMOS_APP_OPEN_NUDGE_CLOSED: {
    name: 'LH_COSMOS_APP_OPEN_NUDGE_CLOSED',
    description: 'Cosmos app open nudge closed'
  },
  LH_COSMOS_APP_OPEN_NUDGE_SHOWN: {
    name: 'LH_COSMOS_APP_OPEN_NUDGE_SHOWN',
    description: 'Cosmos app open nudge shown'
  },
  LH_COSMOS_APP_OPEN_STICKY_NUDGE_SHOWN: {
    name: 'LH_COSMOS_APP_OPEN_STICKY_NUDGE_SHOWN',
    description: 'Cosmos app open sticky nudge shown'
  },
  // AGENT AVAILABILITY
  SIDE_NAV_AGENT_AVAILABILITY_CLICK: {
    name: 'SIDE_NAV_AGENT_AVAILABILITY_CLICK',
    description: 'Agent try to change the availablity(online/offline)'
  },
  AGENT_AVAILABILITY_PAGE_LANDED: {
    name: 'AGENT_AVAILABILITY_PAGE_LANDED',
    description: 'Agent availability page landed'
  },
  AGENT_AVAILABILITY_TL_FILTER_SELECTED: {
    name: 'AGENT_AVAILABILITY_TL_FILTER_SELECTED',
    description: 'Agent availability TL filter selected'
  },
  AGENT_AVAILABILITY_AGENT_FILTER_SELECTED: {
    name: 'AGENT_AVAILABILITY_TL_FILTER_SELECTED',
    description: 'Agent availability agent filter selected'
  },
  AGENT_AVAILABILITY_PAGE_CHANGED: {
    name: 'AGENT_AVAILABILITY_PAGE_CHANGED',
    description: 'Agent availability page changed'
  },
  AGENT_AVAILABILITY_PAGE_SIZE_CHANGED: {
    name: 'AGENT_AVAILABILITY_PAGE_SIZE_CHANGED',
    description: 'Agent availability page size changed'
  },
  AGENT_AVAILABILITY_API_RESPONSE: {
    name: 'AGENT_AVAILABILITY_API_RESPONSE',
    description: 'Agent availability api response'
  },
  LH_SKIPTRACING_PAGELAND: {
    name: 'LH_SKIPTRACING_PAGELAND',
    description: 'User lands on Skip Tracing page'
  },
  LH_LEAVE_MANAGEMENT_PAGE_LANDED: {
    name: 'LEAVE_MANAGEMENT_PAGE_LANDED',
    description: 'Leave management page landed'
  },
  LH_LEAVE_MANAGEMENT_FILTERS: {
    name: 'LEAVE_MANAGEMENT_FILTERS',
    description: 'Leave management applied filters'
  },
  LH_LEAVE_MANAGEMENT_PREVIOUS_MONTH: {
    name: 'LEAVE_MANAGEMENT_PREVIOUS_MONTH',
    description: 'Leave management previous month data'
  },
  LH_LEAVE_MANAGEMENT_NEXT_MONTH: {
    name: 'LEAVE_MANAGEMENT_NEXT_MONTH',
    description: 'Leave management next month data'
  },
  LH_TELE_SENSEI_SidePanelIconClick: {
    name: 'LH_TELE_SENSEI_SidePanelIconClick_',
    description: 'Click on Tele sensei option on Side Panel'
  },
  // sensai
  LH_FIELD_DASHBOARD_PAGE_LOAD: {
    name: 'LH_FIELD_DASHBOARD_PAGE_LOAD',
    description: 'Field dashboard page load'
  },
  LH_FIELD_DASHBOARD_COMMITMENT_CASH_EDITED: {
    name: 'LH_FIELD_DASHBOARD_COMMITMENT_CASH_EDITED',
    description: 'Field dashboard commitment cash edited'
  },
  LH_FIELD_DASHBOARD_COMMITMENT_VISIT_EDITED: {
    name: 'LH_FIELD_DASHBOARD_COMMITMENT_VISIT_EDITED',
    description: 'Field dashboard commitment visit edited'
  },
  LH_FIELD_DASHBOARD_REASON_FOR_CASH_DEVIATION_ADDED: {
    name: 'LH_FIELD_DASHBOARD_REASON_FOR_CASH_DEVIATION_ADDED',
    description: 'Field dashboard reason added'
  },
  LH_FIELD_DASHBOARD_REASON_FOR_VISIT_DEVIATION_ADDED: {
    name: 'LH_FIELD_DASHBOARD_REASON_FOR_VISIT_DEVIATION_ADDED',
    description: 'Field dashboard reason added'
  },
  LH_FIELD_DASHBOARD_Remarks_ADDED: {
    name: 'LH_FIELD_DASHBOARD_Remarks_ADDED',
    description: 'Field dashboard remarks added'
  },
  LH_FIELD_DASHBOARD_SIDE_PANEL_CLICK: {
    name: 'LH_FIELD_DASHBOARD_SIDE_PANEL_CLICK',
    description: 'Field dashboard side panel click'
  },
  LH_TELE_SENSEI_SIDE_PANEL_CLICK: {
    name: 'LH_TELE_SENSEI_SIDE_PANEL_CLICK',
    description: 'Tele sensei side panel click'
  },
  LH_TELE_SENSEI_FILTERS: {
    name: 'LH_TELE_SENSEI_FILTERS',
    description: 'Tele sensei applied filters'
  },
  LH_TELE_SENSEI_FILTER_APPLY: {
    name: 'LH_TELE_SENSEI_FILTER_APPLY',
    description: 'Tele sensei filter apply'
  },
  LH_TELE_SENSEI_PAGE_LOAD: {
    name: 'LH_TELE_SENSEI_PAGE_LOAD',
    description: 'Tele sensei page load'
  },
  LH_TELE_SENSEI_AGENT_PERFORMANCE_DOWNLOAD: {
    name: 'LH_TELE_SENSEI_AGENT_PERFORMANCE_DOWNLOAD',
    description: 'Tele sensei download'
  },
  LH_TELE_SENSEI_DOWNLOAD_AGENT_DESPOSITION_DOWNLOAD: {
    name: 'LH_TELE_SENSEI_DOWNLOAD_AGENT_DESPOSITION_DOWNLOAD',
    description: 'Tele sensei download'
  },
  LH_TLE_SENSEI_DOWNLOAD_AGENT_INPUT_DOWNLOAD: {
    name: 'LH_TLE_SENSEI_DOWNLOAD_AGENT_INPUT_DOWNLOAD',
    description: 'Tele sensei download'
  },
  LH_AMEYO_CALL_DISABLED_ACCEPT_CLICKED: {
    name: 'LH_AMEYO_CALL_DISABLED_ACCEPT_CLICKED',
    description: 'When accept button is clicked in disabled state.'
  },
  LH_AMEYO_CALL_DISABLED_REJECT_CLICKED: {
    name: 'LH_AMEYO_CALL_DISABLED_REJECT_CLICKED',
    description: 'When reject button is clicked in disabled state.'
  },
  LH_AMEYO_CALL_DISABLED_DISCONNECT_CLICKED: {
    name: 'LH_AMEYO_CALL_DISABLED_DISCONNECT_CLICKED',
    description: 'When disconnect button is clicked in disabled state.'
  },
  LH_AGENCY_UTILS_CLICKED: {
    name: 'LH_AGENCY_UTILS_CLICKED',
    description: 'Agency utils clicked'
  },
  LH_AMEYO_PONG_RECEIVED_AMEYO: {
    name: 'LH_AMEYO_PONG_RECEIVED_AMEYO',
    description: 'When pong is received from ameyo.'
  },
  LH_AMEYO_PONG_RECEIVED_LONGHORN: {
    name: 'LH_AMEYO_PONG_RECEIVED_LONGHORN',
    description: 'When pong is received from longhorn.'
  },

  // External Dashboard - Sensei
  LH_FIELD_DASHBOARD_FILTER_CLICKED: {
    name: 'LH_FIELD_DASHBOARD_FILTER_CLICKED',
    description: 'Field dashboard filter clicked'
  },
  LH_FIELD_DASHBOARD_FILTER_APPLIED: {
    name: 'LH_FIELD_DASHBOARD_FILTER_APPLIED',
    description: 'Field dashboard filter applied'
  },
  LH_FIELD_DASHBOARD_SORT_CHANGED: {
    name: 'LH_FIELD_DASHBOARD_SORT_CHANGED',
    description: 'Field dashboard sort changed'
  },
  LH_FIELD_DASHBOARD_PAGE_CHANGED: {
    name: 'LH_FIELD_DASHBOARD_PAGE_CHANGED',
    description: 'Field dashboard page changed'
  },
  LH_FIELD_DASHBOARD_PAGE_SIZE_CHANGED: {
    name: 'LH_FIELD_DASHBOARD_PAGE_SIZE_CHANGED',
    description: 'Field dashboard page size changed'
  },
  LH_FIELD_DASHBOARD_TAB_SWITCH: {
    name: 'LH_FIELD_DASHBOARD_TAB_SWITCH',
    description: 'Field dashboard tab switch'
  },
  LH_FIELD_DASHBOARD_PAGE_LAND: {
    name: 'LH_FIELD_DASHBOARD_PAGE_LAND',
    description: 'Field dashboard page land'
  },
  LH_FIELD_DASHBOARD_GOVERNANCE_TAB_SWITCH: {
    name: 'LH_FIELD_DASHBOARD_GOVERNANCE_TAB_SWITCH',
    description: 'Field dashboard governance tab switch'
  },

  // Agency Dashboard - Longhorn
  CLICK_OUTPUT_METRICS_TAB: {
    name: 'CLICK_OUTPUT_METRICS_TAB',
    description: 'Agency output metrics tab clicked'
  },
  CLICK_INPUT_METRICS_TAB: {
    name: 'CLICK_INPUT_METRICS_TAB',
    description: 'Agency input metrics tab clicked'
  },
  SELECT_HIERARCHY_FROM_DROPDOWN: {
    name: 'SELECTED_HIERARCHY_FRON_DROPDOWN',
    description: 'Selected a hierarchy from the Select Hierarchy dropdown'
  },
  SELECT_FPR_VALUE_DROPDOWN: {
    name: 'SELECT_FPR_VALUE_DROPDOWN',
    description: 'Selects the FPR filter dropdown'
  },
  SELECT_ADM_VALUE_DROPDOWN: {
    name: 'SELECT_ADM_VALUE_DROPDOWN',
    description: 'Selects the ADM filter dropdown'
  },
  CHOOSE_BUCKET_VALUE: {
    name: 'CHOOSE_BUCKET_VALUE',
    description: 'Selects a bucket from dropdown'
  },
  CLICK_HOURLY_VIEW: {
    name: 'CLICK_HOURLY_VIEW',
    description: 'Switches to Hourly tab'
  },
  CLICK_DAILY_VIEW: {
    name: 'CLICK_DAILY_VIEW',
    description: 'Switches to Daily tab'
  },
  CLICK_PAGINATION_NUMBER: {
    name: 'CLICK_PAGINATION_NUMBER',
    description: 'Clicking a page number'
  },

  LH_SCREEN_WIDTH_HEIGHT: {
    name: 'LH_SCREEN_WIDTH_HEIGHT',
    description: 'Screen width and height'
  },
  LH_SKIPTRACING_GST_EMAIL_COPY: {
    name: 'LH_SKIPTRACING_GST_EMAIL_COPY',
    description: 'Skiptracing GST email copy'
  },
  LH_SKIPTRACING_GST_ADDRESS_COPY: {
    name: 'LH_SKIPTRACING_GST_ADDRESS_COPY',
    description: 'Skiptracing GST address copy'
  },
  LH_SKIPTRACING_GST_GSTIN_COPY: {
    name: 'LH_SKIPTRACING_GST_GSTIN_COPY',
    description: 'Skiptracing GST GSTIN copy'
  },
  LH_SKIPTRACING_GST_BUSINESS_NAME_COPY: {
    name: 'LH_SKIPTRACING_GST_BUSINESS_NAME_COPY',
    description: 'Skiptracing GST business name copy'
  },
  LH_SKIPTRACING_EPFO_ORGANISATION_NAME_COPY: {
    name: 'LH_SKIPTRACING_EPFO_ORGANISATION_NAME_COPY',
    description: 'Skiptracing EPFO organisation name copy'
  },
  LH_SKIPTRACING_EPFO_OFFICE_COPY: {
    name: 'LH_SKIPTRACING_EPFO_OFFICE_COPY',
    description: 'Skiptracing EPFO office copy'
  },
  LH_SKIPTRACING_GST_REGISTERED_NAME_COPY: {
    name: 'LH_SKIPTRACING_GST_REGISTERED_NAME_COPY',
    description: 'Skiptracing GST registered name copy'
  },
  LH_TELE_WA_CHAT_FEEDBACK_FORM_LOADED: {
    name: 'LH_TELE_WA_CHAT_FEEDBACK_FORM_LOADED',
    description: 'Tele whatsapp chat feedback form loaded'
  },
  LH_TELE_WA_CHAT_FEEDBACK_FORM_SUBMITTED_SUCCESSFULLY: {
    name: 'LH_TELE_WA_CHAT_FEEDBACK_FORM_SUBMITTED_SUCCESSFULLY',
    description: 'Tele whatsapp chat feedback form submitted successfully'
  },
  LH_TELE_WA_CHAT_FEEDBACK_FORM_SUBMISSION_FAILED: {
    name: 'LH_TELE_WA_CHAT_FEEDBACK_FORM_SUBMISSION_FAILED',
    description: 'Tele whatsapp chat feedback form submission failed'
  },
  LH_TELE_WA_CHAT_BOLD_FONT_SELECTED: {
    name: 'LH_TELE_WA_CHAT_BOLD_FONT_SELECTED',
    description: 'Tele whatsapp chat click on Bold font Icon'
  },
  LH_TELE_WA_CHAT_ITALICS_FONT_SELECTED: {
    name: 'LH_TELE_WA_CHAT_ITALICS_FONT_SELECTED',
    description: 'Tele whatsapp chat click on Italics font Icon'
  },
  LH_TELE_WA_CHAT_IMAGE_SENDING_SELECTED: {
    name: 'LH_TELE_WA_CHAT_IMAGE_SENDING_SELECTED',
    description: 'Tele whatsapp chat click on Attachment Icon'
  },
  LH_OVERALL_PERFORMANCE_FILTER_CHANGE: {
    name: 'LH_OVERALL_PERFORMANCE_FILTER_CHANGE',
    description: 'Overall performance CCM RM filter change'
  },
  LH_ACTIVITY_TRACKER_PAGE_VIEW: {
    name: 'LH_ACTIVITY_TRACKER_PAGE_VIEW',
    description: 'Activity tracker page view'
  },
  // CSA
  LH_TASKS_TAB_CLICKED: {
    name: 'LH_TASKS_TAB_CLICKED',
    description: 'Tasks tab clicked'
  },
  LH_TASKS_LOAD_SUCCESSFUL: {
    name: 'LH_TASKS_LOAD_SUCCESSFUL',
    description: 'Tasks load successful'
  },
  LH_CREATE_TASK_CLICKED: {
    name: 'LH_CREATE_TASK_CLICKED',
    description: 'Create task clicked'
  },
  LH_CREATE_TASK_SUCCESSFUL: {
    name: 'LH_CREATE_TASK_SUCCESSFUL',
    description: 'Create task successful'
  },
  LH_TASK_DETAIL_CLICKED: {
    name: 'LH_TASK_DETAIL_CLICKED',
    description: 'Task detail clicked'
  },
  LH_TASK_DETAIL_LOAD_SUCCESSFUL: {
    name: 'LH_TASK_DETAIL_LOAD_SUCCESSFUL',
    description: 'Task detail load successful'
  },
  LH_TASKS_BUTTON_CLICKED: {
    name: 'LH_TASKS_BUTTON_CLICKED',
    description: 'Tasks button clicked'
  },
  LH_TASKS_PAGE_LOAD_SUCCESSFUL: {
    name: 'LH_TASKS_PAGE_LOAD_SUCCESSFUL',
    description: 'Tasks page load successful'
  },
  LH_TASKS_TAB_BUTTON_CLICKED: {
    name: 'LH_TASKS_TAB_BUTTON_CLICKED',
    description: 'Tasks tab button clicked'
  },
  LH_MY_TASKS_LOAD_SUCCESSFUL: {
    name: 'LH_MY_TASKS_LOAD_SUCCESSFUL',
    description: 'My tasks load successful'
  },
  LH_FE_TASKS_LOAD_SUCCESSFUL: {
    name: 'LH_FE_TASKS_LOAD_SUCCESSFUL',
    description: 'FE tasks load successful'
  },
  LH_TASK_STATUS_DROPDOWN_CLICKED: {
    name: 'LH_TASK_STATUS_DROPDOWN_CLICKED',
    description: 'Task status dropdown clicked'
  },
  LH_TASK_MARKED_DONE_BUTTON_CLICKED: {
    name: 'LH_TASK_MARKED_DONE_BUTTON_CLICKED',
    description: 'Task marked done button clicked'
  },
  LH_TASK_STATUS_UPDATED_SUCCESSFUL: {
    name: 'LH_TASK_STATUS_UPDATED_SUCCESSFUL',
    description: 'Task status updated successful'
  },
  LH_TASK_COMMENT_ADDED: {
    name: 'LH_TASK_COMMENT_ADDED',
    description: 'Task comment added'
  },
  LH_TASK_VIEW_DETAIL_CLICKED: {
    name: 'LH_TASK_VIEW_DETAIL_CLICKED',
    description: 'Task view detail clicked'
  },
  LH_TASKS_UNREAD_TOGGLE_CLICKED: {
    name: 'LH_TASKS_UNREAD_TOGGLE_CLICKED',
    description: 'Tasks unread toggle clicked'
  },
  LH_MAP_VIEW_INCORRECT_DATA: {
    name: 'LH_MAP_VIEW_INCORRECT_DATA',
    description: 'Wrong reference id in url of map view'
  },
  LH_FIELD_AGENT_COSMOS_DOWNLOAD_BUTTON_CLICKED: {
    name: 'LH_FIELD_AGENT_COSMOS_DOWNLOAD_BUTTON_CLICKED',
    description: 'Cosmos download button clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_PAGE_LAND: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_PAGE_LAND',
    description: 'Bank Statement Page Land'
  },
  LH_DOCUMENTS_BANK_STATEMENT_SEARCH: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_SEARCH',
    description: 'Bank Statament Search transaction clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_FILTER_NUMBER: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_FILTER_NUMBER',
    description: 'Bank Statement filter phone number clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_REMOVE_FILTERS: {
    name: 'LH_DOCUMENTS_BANKSTATEMENT_REMOVE_FILTERS',
    description: 'Bank Statement remove filters clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_EXPANDVIEW: {
    name: 'LH_DOCUMENTS_BANKSTATEMENT_EXPANDVIEW',
    description: 'Bank Statement  Expand view clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_COLLAPSED_FROM_EXPAND: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_COLLAPSED_FROM_EXPAND',
    description: 'Bank Statement collapse from expanded view clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_HYPERLINKING_POPPER: {
    name: 'LH_DOCUMENTS_BANKSTATEMENT_HYPERLINKING_POPPER',
    description: 'Bank Statement hyperlinking popper clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_ADD_PHONE_NUMBER: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_ADD_PHONE_NUMBER',
    description: 'Bank Statement PhoneNumber Add from Popper clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_INITIATE_CALL: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_INITIATE_CALL',
    description: 'Bank Statement initiate call from popper clicked'
  },
  LH_DOCUMENTS_BANK_STATEMENT_ADD_NUMBER_AND_INITIATE_CALL: {
    name: 'LH_DOCUMENTS_BANK_STATEMENT_ADD_NUMBER_AND_INITIATE_CALL',
    description: 'Bank Statement add number and initiate call from popper clicked '
  },

  // CSA Dashboard
  LH_CSA_DASHBOARD_TAB_CLICKED: {
    name: 'LH_CSA_DASHBOARD_TAB_CLICKED',
    description: 'Csa dashboard tab clicked'
  },
  LH_CSA_DASHBOARD_PAGE_LOADED: {
    name: 'LH_CSA_DASHBOARD_PAGE_LOADED',
    description: 'Csa dashboard page loaded'
  },
  LH_CSA_DASHBOARD_PTPS_OVERVIEW_FILTER_CLICKED: {
    name: 'LH_CSA_DASHBOARD_PTPS_OVERVIEW_FILTER_CLICKED',
    description: 'Csa dashboard ptps overview filter clicked'
  },
  LH_CSA_DASHBOARD_PTPS_OVERVIEW_FILTER_APPLIED: {
    name: 'LH_CSA_DASHBOARD_PTPS_OVERVIEW_FILTER_APPLIED',
    description: 'Csa dashboard ptps overview filter applied'
  },
  LH_CSA_DASHBOARD_REFRESH_CLICKED: {
    name: 'LH_CSA_DASHBOARD_REFRESH_CLICKED',
    description: 'Csa dashboard refresh clicked'
  },
  LH_CSA_DASHBOARD_PTPS_GENERATED_FILTER_CLICKED: {
    name: 'LH_CSA_DASHBOARD_PTPS_GENERATED_FILTER_CLICKED',
    description: 'Csa dashboard ptps generated filter clicked'
  },
  LH_CSA_DASHBOARD_PTPS_GENERATED_FILTER_APPLIED: {
    name: 'LH_CSA_DASHBOARD_PTPS_GENERATED_FILTER_APPLIED',
    description: 'Csa dashboard ptps generated filter applied'
  },
  LH_CSA_DASHBOARD_TASKS_CREATED_FILTER_CLICKED: {
    name: 'LH_CSA_DASHBOARD_TASKS_CREATED_FILTER_CLICKED',
    description: 'Csa dashboard tasks created filter clicked'
  },
  LH_CSA_DASHBOARD_TASKS_CREATED_FILTER_APPLIED: {
    name: 'LH_CSA_DASHBOARD_TASKS_CREATED_FILTER_APPLIED',
    description: 'Csa dashboard tasks created filter applied'
  },
  LH_CSA_DASHBOARD_PTPS_GENERATED_ROW_EXPANDED: {
    name: 'LH_CSA_DASHBOARD_PTPS_GENERATED_ROW_EXPANDED',
    description: 'Csa dashboard ptps generated row expanded'
  },
  LH_AMEYO_LOGIN_FAILED: {
    name: 'LH_AMEYO_LOGIN_FAILED',
    description: 'Ameyo login failed'
  },
  LH_UniversalCallSDK_CLICKSTREAM_PROCESSOR: {
    name: 'LH_UniversalCallSDK_CLICKSTREAM_PROCESSOR',
    description: 'Universal Call SDK Clickstream Processor'
  },
  LH_SNOOZE_EFFORTS_SUBMITTED: {
    name: 'LH_SNOOZE_EFFORTS_SUBMITTED',
    description: 'Snooze Efforts Submitted'
  },
  LH_SNOOZE_EFFORTS_UPDATED: {
    name: 'LH_SNOOZE_EFFORTS_UPDATED',
    description: 'Snooze Efforts Updated'
  },
  LH_SNOOZE_EFFORTS_Filter_CLICKED: {
    name: 'LH_SNOOZE_EFFORTS_Filter_CLICKED',
    description: 'Snooze Efforts Filter Clicked'
  },
  // Anomaly Tracker
  LH_ANOMALY_TRACKER_TAB_CHANGE: {
    name: 'LH_ANOMALY_TRACKER_TAB_CHANGE',
    description: 'Anomaly Tracker tab change'
  },
  LH_ANOMALY_TRACKER_PAGE_LOAD: {
    name: 'LH_ANOMALY_TRACKER_PAGE_LOAD',
    description: 'Anomaly Tracker page load'
  },
  LH_ANOMALY_TRACKER_PAGINATION_CHANGE: {
    name: 'LH_ANOMALY_TRACKER_PAGINATION_CHANGE',
    description: 'Anomaly Tracker pagination change'
  },
  LH_ANOMALY_TRACKER_ANOMALY_CLICK: {
    name: 'LH_ANOMALY_TRACKER_ANOMALY_CLICK',
    description: 'Anomaly Tracker anomaly click'
  },
  LH_ANOMALY_TRACKER_ANOMALY_COPY_LINK_CLICKED: {
    name: 'LH_ANOMALY_TRACKER_ANOMALY_COPY_LINK_CLICKED',
    description: 'Anomaly Tracker copy link click'
  },
  LH_ANOMALY_TRACKER_SINGLE_ANOMALY_LOADED: {
    name: 'LH_ANOMALY_TRACKER_SINGLE_ANOMALY_LOADED',
    description: 'Anomaly Tracker single anomaly loaded'
  },
  LH_ANOMALY_TRACKER_ANOMALY_ETA_SUBMIT_BUTTON_CLICKED: {
    name: 'LH_ANOMALY_TRACKER_ANOMALY_ETA_SUBMIT_BUTTON_CLICKED',
    description: 'Anomaly Tracker anomaly eta added'
  },
  LH_ANOMALY_TRACKER_ANOMALY_RCA_SUBMIT_BUTTON_CLICKED: {
    name: 'LH_ANOMALY_TRACKER_ANOMALY_RCA_SUBMIT_BUTTON_CLICKED',
    description: 'Anomaly Tracker anomaly eta edited'
  },
  LH_ANOMALY_TRACKER_ANOMALY_RESOLVED_SUBMIT_BUTTON_CLICKED: {
    name: 'LH_ANOMALY_TRACKER_ANOMALY_RESOLVED_SUBMIT_BUTTON_CLICKED',
    description: 'Anomaly Tracker anomaly resolved'
  },

  // PAN Approval
  LH_CLICKED_PAN_CARDS: {
    name: 'LH_CLICKED_PAN_CARDS',
    description: 'When a user clicks on PAN Cards sub section in Approvals tab    '
  },
  LH_CLICKED_ID_CARDS: {
    name: 'LH_CLICKED_ID_CARDS',
    description: 'When a user clicks on ID Cards sub section in Approvals tab'
  },
  LH_CLICKED_ID_APPROVALS: {
    name: 'LH_CLICKED_ID_APPROVALS',
    description: 'When a user clicks on approvals tab on LH'
  },
  LH_PAN_CARD_LOADED: {
    name: 'LH_PAN_CARD_LOADED',
    description: 'When PAN card data is loaded'
  },
  LH_CLICKED_PAN_CARDS_REJECT: {
    name: 'LH_CLICKED_PAN_CARDS_REJECT',
    description: 'When a user clicks on reject button in PAN Cards sub section in Approvals tab'
  },
  LH_CLICKED_PAN_CARDS_APPROVED: {
    name: 'LH_CLICKED_PAN_CARDS_APPROVED',
    description: 'When a user clicks on approve button in PAN Cards sub section in Approvals tab'
  },
  LH_APPROVAL_PAN_EXPANDED_VIEW_OPENED: {
    name: 'LH_APPROVAL_PAN_EXPANDED_VIEW_OPENED',
    description: 'When a user opens the expanded view of PAN card'
  },
  LH_AGENCY_ALLOCATION_FILE_SIZE_FAILURE: {
    name: 'LH_AGENCY_ALLOCATION_FILE_SIZE_FAILURE',
    description: 'Agency allocation failure'
  },
  LH_AGENCY_ALLOCATION_FILE_VALIDATION_FAILURE: {
    name: 'LH_AGENCY_ALLOCATION_FILE_VALIDATION_FAILURE',
    description: 'Column data/headers are incorrect'
  },
  LH_Reports_CaseLevel_DownloadClick: {
    name: 'LH_Reports_CaseLevel_DownloadClick',
    description: 'Download button Click in Case level report'
  },
  LH_Reports_UnifiedCaseLevelReport_DownloadClick: {
    name: 'LH_Reports_UnifiedCaseLevelReport_DownloadClick',
    description: 'Download button Click in Unified case level report'
  },
  LH_Reports_AggregatedNotification_DownloadClick: {
    name: 'LH_Reports_AggregatedNotification_DownloadClick',
    description: 'Download button Click in Aggregated notification report'
  },
  LH_Reports_Feedback_DownloadClick: {
    name: 'LH_Reports_Feedback_DownloadClick',
    description: 'Download button Click in Feedback report'
  },
  LH_Reports_Payment_DownloadClick: {
    name: 'LH_Reports_Payment_DownloadClick',
    description: 'Download button Click in Payment report'
  },
  LH_Reports_Case1630_DownloadClick: {
    name: 'LH_Reports_Case1630_DownloadClick',
    description: 'Download button Click in Case level report for 16-30 field'
  },
  LH_Reports_Feedback1630_DownloadClick: {
    name: 'LH_Reports_Feedback1630_DownloadClick',
    description: 'Download button Click in Feedback report for 16-30 field'
  },
  LH_Reports_CaseInhouse_DownloadClick: {
    name: 'LH_Reports_CaseInhouse_DownloadClick',
    description: 'Download button Click in Case level report for inhouse field'
  },
  LH_Reports_AgencyCase_DownloadClick: {
    name: 'LH_Reports_AgencyCase_DownloadClick',
    description: 'Download button Click in Agency case level report'
  },
  LH_Reports_CaseInhouseTele_DownloadClick: {
    name: 'LH_Reports_CaseInhouseTele_DownloadClick',
    description: 'Download button Click in Case level report for inhouse tele'
  },
  LH_Reports_FeedbackInhouseTele_DownloadClick: {
    name: 'LH_Reports_FeedbackInhouseTele_DownloadClick',
    description: 'Download button Click in Feedback report for inhouse tele'
  },
  LH_Reports_AgentInhouseTele_DownloadClick: {
    name: 'LH_Reports_AgentInhouseTele_DownloadClick',
    description: 'Download button Click in Agent report for inhouse tele'
  },
  LH_Reports_CosmosAgent_DownloadClick: {
    name: 'LH_Reports_CosmosAgent_DownloadClick',
    description: 'Download button Click in Cosmos agent report'
  },
  LH_Reports_Case30Plus_DownloadClick: {
    name: 'LH_Reports_Case30Plus_DownloadClick',
    description: 'Download button Click in Case level report for 30 plus tele'
  },
  LH_Reports_Feedback30Plus_DownloadClick: {
    name: 'LH_Reports_Feedback30Plus_DownloadClick',
    description: 'Download button Click in Feedback report for 30 plus tele'
  },
  LH_CASE_RECOMMENDATION_DASHBOARD_BANNER_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_DASHBOARD_BANNER_CLICK',
    description: 'Click on Case Recommendation banner on Dashboard'
  },
  LH_CASE_RECOMMENDATION_START_OR_RESUME_CALLING_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_START_OR_RESUME_CALLING_CLICK',
    description: 'Click on Start or Resume Calling button in Case Recommendation Modal'
  },
  LH_CASE_RECOMMENDATION_REFRESH_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_REFRESH_CLICK',
    description: 'Click on Refresh button in Case Recommendation Modal'
  },
  LH_CASE_RECOMMENDATION_NAVIGATION_PREV_CASE_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_NAVIGATION_PREV_CASE_CLICK',
    description: 'Click on Previous Case button in case recommendation navigation footer'
  },
  LH_CASE_RECOMMENDATION_NAVIGATION_NEXT_CASE_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_NAVIGATION_NEXT_CASE_CLICK',
    description: 'Click on Next Case button in case recommendation navigation footer'
  },
  LH_CASE_RECOMMENDATION_NAVIGATION_BACK_TO_RECOMMENDED_CASES_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_NAVIGATION_BACK_TO_RECOMMENDED_CASES_CLICK',
    description:
      'Click on Back to Recommended Cases button in case recommendation navigation footer'
  },
  LH_CASE_RECOMMENDATION_CASES_PAGE_BANNER_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_CASES_PAGE_BANNER_CLICK',
    description: 'Click on Case Recommendation banner on Cases page'
  },
  LH_CASE_RECOMMENDATION_FILTER_DRAWER_BANNER_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_FILTER_DRAWER_BANNER_CLICK',
    description: 'Click on Case Recommendation banner on Filter Drawer page'
  },
  LH_CASE_RECOMMENDATION_STRATEGY_CHIP_V2_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_STRATEGY_CHIP_V2_CLICK',
    description: 'Click on a strategy chip in case recommendation dashboard'
  },
  LH_CASE_RECOMMENDATION_FILTER_CHANGE_V2_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_FILTER_CHANGE_V2_CLICK',
    description: 'User changed filter during case recommendation navigation'
  },
  LH_CASE_RECOMMENDATION_START_AGAIN_V2_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_START_AGAIN_V2_CLICK',
    description: 'Click on start again in end of navigation modal'
  },
  LH_CASE_RECOMMENDATION_CHANGE_STRATEGY_V2_CLICK: {
    name: 'LH_CASE_RECOMMENDATION_CHANGE_STRATEGY_V2_CLICK',
    description: 'Click on change strategy in end of navigation modal'
  },
  LH_ADD_NEW_ADDRESS: {
    name: 'LH_ADD_NEW_ADDRESS',
    description: 'Submit new address button clicked'
  },
  COSMOS_UPDATE_REQUIRED_MODAL_SHOWN: {
    name: 'COSMOS_UPDATE_REQUIRED_MODAL_SHOWN',
    description: 'User shown Cosmos app update required modal blocking Longhorn access'
  },
  LH_CALL_LIMIT_SIDE_PANEL_CLICK: {
    name: 'LH_CALL_LIMIT_SIDE_PANEL_CLICK',
    description: 'Call limit side panel click'
  },
  LH_COSMOS_SYNC_BLOCK_STATUS_CHANGED: {
    name: 'LH_COSMOS_SYNC_BLOCK_STATUS_CHANGED',
    description: 'Longhorn agent status changed'
  }
});

export const CLICKSTREAM_EVENT_NAMES_FA = Object.freeze({
  LH_Home_ViewAllCasesClick_FA: 'LH_Home_ViewAllCasesClick_FA',
  // all cases
  LH_Cases_PageLand_FA: 'LH_Cases_PageLand_FA',
  LH_Cases_SearchClick_FA: 'LH_Cases_SearchClick_FA',
  LH_Cases_FilterClick_FA: 'LH_Cases_FilterClick_FA',
  LH_Cases_SearchSuccess_FA: 'LH_Cases_SearchSuccess_FA',
  LH_Cases_FilterSuccess_FA: 'LH_Cases_FilterSuccess_FA',
  LH_Cases_SortClick_FA: 'LH_Cases_SortClick_FA',
  LH_Cases_SortSuccess_FA: 'LH_Cases_SortSuccess_FA',
  // case details
  LH_CaseDetails_TabClick_FA: 'LH_CaseDetails_TabClick_FA',
  LH_CaseDetails_PageLand_FA: 'LH_CaseDetails_PageLand_FA',
  // repayments tab
  LH_CaseDetails_Repayments_FA: 'LH_CaseDetails_Repayments_FA',
  LH_Repaymnets_PageLand_FA: 'LH_Repayments_PageLand_FA',
  // EMI Scedule Tab
  LH_EMISchedule_TabClick_FA: 'LH_EMISchedule_TabClick_FA',
  LH_CaseDetails_EMIUnpaid_FA: 'LH_CaseDetails_EMIUnpaid_FA',
  LH_CaseDetails_EMIPaid_FA: 'LH_CaseDetails_EMIPaid_FA',
  LH_CaseDetails_EMIAll_FA: 'LH_CaseDetails_EMIAll_FA',
  // Feedback
  LH_Feedback_ExpansionPanelClick_FA: 'LH_Feedback_ExpansionPanelClick_FA',
  LH_AddFeedbackclick_FA: 'LH_AddFeedbackclick_FA',
  LH_Feedback_InteractionStatusClick_FA: 'LH_Feedback_InteractionStatusClick_FA',
  LH_Feedback_SubmitCTA_FA: 'LH_Feedback_SubmitCTA_FA',
  LH_Feedback_DispositionCross_FA: 'LH_Feedback_DispositionCross_FA',
  // Payment tab
  LH_Payment_TabClick_FA: 'LH_Payment_TabClick_FA',
  LH_Payment_PageLand_FA: 'LH_Payment_PageLand_FA',
  LH_Payment_SendPaymentCTA_FA: 'LH_Payment_SendPaymentCTA_FA',
  LH_Payment_CopyPaymentCTA_FA: 'LH_Payment_CopyPaymentCTA_FA',
  // Info Tab
  LH_Info_TabClick_FA: 'LH_Info_TabClick_FA',
  LH_Info_PageLand_FA: 'LH_Info_PageLand_FA',
  // Phone No tab
  LH_PhoneNo_TabClick_FA: 'LH_PhoneNo_TabClick_FA',
  LH_PhoneNo_PageLand_FA: 'LH_PhoneNo_PageLand_FA',
  LH_PhoneNo_AddPhnCTA_FA: 'LH_PhoneNo_AddPhnCTA_FA',
  LH_PhoneNo_AddCTA_FA: 'LH_PhoneNo_AddPhnCTA_FA',
  // Address tab
  LH_Address_TabClick_FA: 'LH_Address_TabClick_FA',
  LH_Address_PageLand_FA: 'LH_Address_PageLand_FA',
  LH_Address_AddCTA_FA: 'LH_Address_AddCTA_FA',
  // Documents tab
  LH_Documents_TabClick_FA: 'LH_Documents_TabClick_FA',
  LH_Documents_PageLand_FA: 'LH_Documents_PageLand_FA',
  LH_Documents_DropDown_FA: 'LH_Documents_DropDown_FA',
  LH_Documents_VKYC_PLAY_FA: 'LH_Documents_VKYC_Play_FA',
  // notification
  LH_Notifications_IconClick_FA: 'LH_Notifications_IconClick_FA',
  LH_Notifications_NotifClick_FA: 'LH_Notifications_NotifClick_FA'
});

export const CLICKSTREAM_EVENT_NAMES_DC: Record<string, IClickStreamEvent> = {
  //ACTIONS TO EXTENSION
  DC_97_AMEYO_ENABLE: { name: 'AMEYO_ENABLE', description: 'Ameyo enable event is fired' },
  DC_97_AMEYO_DISABLE: { name: 'AMEYO_DISABLE', description: 'Ameyo disable event is fired' },
  DC_97_AMEYO_LOGIN: { name: 'DC_97_AMEYO_LOGIN', description: 'Ameyo login event is fired' },
  DC_97_AMEYO_LOGOUT: { name: 'DC_97_AMEYO_LOGOUT', description: 'Ameyo logout event is fired' },
  DC_97_AMEYO_AVAILABILITY_CHANGE: {
    name: 'DC_97_AMEYO_AVAILABILITY_CHANGE',
    description: 'Ameyo availability change is fired'
  },
  DC_97_AMEYO_ACCEPT_CALL: {
    name: 'DC_97_AMEYO_ACCEPT_CALL',
    description: 'Ameyo accept event is fired'
  },
  DC_97_AMEYO_REJECT_CALL: {
    name: 'DC_97_AMEYO_REJECT_CALL',
    description: 'Ameyo reject call is fired'
  },
  DC_97_AMEYO_DISCONNECT_CALL: {
    name: 'DC_97_AMEYO_DISCONNECT_CALL',
    description: 'Ameyo disconnect call is fired'
  },
  DC_97_AMEYO_FEEDBACK_PENDING_STATUS: {
    name: 'DC_97_AMEYO_FEEDBACK_PENDING_STATUS',
    description: 'Ameyo feedback staus is fired'
  },
  DC_97_AMEYO_DISPOSE: { name: 'DC_97_AMEYO_DISPOSE', description: 'Ameyo dispose is fired' },
  DC_97_AMEYO_RESET_CALL_STATUS: {
    name: 'DC_97_RESET_ALL_AMEYO_STATE',
    description: 'Ameyo reset all state is fired'
  },
  DC_97_AMEYO_RESET_ALL_DATA: {
    name: 'DC_97_AMEYO_RESET_ALL_DATA',
    description: 'Reset all Ameyo data is fired'
  },
  DC_97_AMEYO_REGISTER_ALL_CALLBACKS: {
    name: 'DC_97_AMEYO_REGISTER_ALL_CALLBACKS',
    description: 'Ameyo register all callbacks is fired'
  },
  DC_97_AMEYO_UNREGISTER_ALL_CALLBACKS: {
    name: 'DC_97_AMEYO_UNREGISTER_ALL_CALLBACKS',
    description: 'Ameyo unregister all callbacks is fired'
  },

  //Agent Activity
  DC_97_AGENT_AVAILABILITY_CLICK: {
    name: 'DC_97_AGENT_AVAILABILITY_CLICK',
    description: 'Agent try to change the availablity(online/offline)'
  },
  DC_97_ACCEPT_CLICK: { name: 'DC_97_ACCEPT_CLICK', description: 'Agent accepted the call' },
  DC_97_REJECT_CLICK: { name: 'DC_97_REJECT_CLICK', description: 'Agent rejected the call' },
  DC_97_DISCONNECTED_CLICK: {
    name: 'DC_97_DISCONNECTED_CLICK',
    description: 'Agent disconnected the call'
  },
  DC_97_SEND_PAYMENT_LINK_CLICK: {
    name: 'DC_97_SEND_PAYMENT_LINK_CLICK',
    description: 'Agent sent the payment link'
  },
  DC_97_SUBMIT_FEEDBACK_CLICK: {
    name: 'DC_97_SUBMIT_FEEDBACK_CLICK',
    description: 'Agent submitted the feedback'
  },

  // Api Status
  GET_STATS_API_CALLED: { name: 'GET_STATS_API_CALLED', description: 'Agent stats api is called' },
  GET_STATS_API_SUCCESS: {
    name: 'GET_STATS_API_SUCCESS',
    description: 'Agent  stats data is received'
  },
  GET_STATS_API_FAILURE: { name: 'GET_STATS_API_FAILURE', description: 'Agent stats api failed' },
  ACCEPT_API_CALLED: { name: 'ACCEPT_API_CALLED', description: 'Accept api is Called' },
  ACCEPT_API_SUCCESS: { name: 'ACCEPT_API_SUCCESS', description: 'Accept api success' },
  ACCEPT_API_FAILURE: { name: 'ACCEPT_API_FAILURE', description: 'Accept api failed' },
  GET_CUSTOMER_DETAILS_API_CALLED: {
    name: 'GET_CUSTOMER_DETAILS_API_CALLED',
    description: 'Customer Details api is called'
  },
  GET_CUSTOMER_DETAILS_API_SUCCESS: {
    name: 'GET_CUSTOMER_DETAILS_API_SUCCESS',
    description: 'Customer Details api success'
  },
  GET_CUSTOMER_DETAILS_API_FAILURE: {
    name: 'GET_CUSTOMER_DETAILS_API_FAILURE',
    description: 'Customer Details api  failed'
  },
  FEEDBACK_SUBMISSION_API_CALLED: {
    name: 'FEEDBACK_SUBMISSION_API_CALLED',
    description: 'Feedback submission api is called'
  },
  FEEDBACK_SUBMISSION_API_SUCCESS: {
    name: 'FEEDBACK_SUBMISSION_API_SUCCESS',
    description: 'Feedback submission api success'
  },
  FEEDBACK_SUBMISSION_API_FAILURE: {
    name: 'FEEDBACK_SUBMISSION_API_FAILURE',
    description: 'Feedback submission api failed'
  },
  LH_CALL_AUDIT_SIDE_PANEL_CLICK: {
    name: 'LH_CALL_AUDIT_SIDE_PANEL_CLICK',
    description: 'Call audit side panel click'
  },

  //Other Events
  SHOW_POPUP: { name: 'SHOW_POPUP', description: 'Incoming call popup showed' },
  CLOSE_POPUP: { name: '', description: 'Incoming call popup closed' },
  SHOW_WAITING_SCREEN: { name: '', description: 'Agent is on waiting screen' },
  SHOW_CUSTOMER_DETAILS_SCREEN: { name: '', description: 'Agent is on customer details screen' }

  //CALL Back
};

export const CLICKSTREAM_ERROR_EVENT: Record<string, IClickStreamEvent> = {
  SERVER_ERROR: { name: 'SERVER ERROR', description: '5XX ERROR' },
  CLIENT_ERROR: { name: 'CLIENT ERROR', description: '4XX ERROR' },
  REDIRECTION: { name: 'REDIRECTION', description: '3XX REDIRECTION' },
  CORS_ERROR: { name: 'CORS ERROR', description: 'CORS ERROR' }
};

export const CLICKSTREAM_ERROR_HEARTBEAT: Record<string, IClickStreamEvent> = {
  LONGHORN_USER_HEARTBEAT: { name: 'LONGHORN_USER_HEARTBEAT', description: '5XX ERROR' }
};

export default CLICKSTREAM_GLOBAL_ATTRIBUTES;

export enum AMEYO_TOOLBAR_EVENTS {
  SHOW_CRM = 'SHOW_CRM_AMEYO_EVENT',
  SHOW_CRM_FETCH_DETAILS = 'SHOW_CRM_FETCH_DETAILS_AMEYO_EVENT',
  SHOW_CRM_SET_DETAILS = 'SHOW_CRM_SET_DETAILS_AMEYO_EVENT',
  SHOW_CRM_TELEPHONE = 'SHOW_CRM_TELEPHONE_AMEYO_EVENT',
  AMEYO_CHANGE_AUTH_EVENT_INITIATED = 'AMEYO_CHANGE_AUTH_EVENT_INITIATED',
  AMEYO_CHANGE_AUTH_EVENT_COMPLETED = 'AMEYO_CHANGE_AUTH_EVENT_COMPLETED',
  AMEYO_CHANGE_CONNECTION_EVENT_INITIATED = 'AMEYO_CHANGE_CONNECTION_EVENT_INITIATED',
  AMEYO_CHANGE_CONNECTION_EVENT_COMPLETED = 'AMEYO_CHANGE_CONNECTION_EVENT_COMPLETED',
  AMEYO_GENERIC_EVENTS = 'AMEYO_GENERIC_EVENTS'
}
export const AMEYO_TOOLBAR_CLICKSTREAM: Record<AMEYO_TOOLBAR_EVENTS, IClickStreamEvent> =
  Object.freeze({
    [AMEYO_TOOLBAR_EVENTS.SHOW_CRM]: {
      name: AMEYO_TOOLBAR_EVENTS.SHOW_CRM,
      description: 'event when toolbar starts to wrong'
    },
    [AMEYO_TOOLBAR_EVENTS.SHOW_CRM_FETCH_DETAILS]: {
      name: AMEYO_TOOLBAR_EVENTS.SHOW_CRM_FETCH_DETAILS,
      description: 'fetch the customer details id from the data received in show crm event'
    },
    [AMEYO_TOOLBAR_EVENTS.SHOW_CRM_SET_DETAILS]: {
      name: AMEYO_TOOLBAR_EVENTS.SHOW_CRM_SET_DETAILS,
      description: 'set the details in component store'
    },
    [AMEYO_TOOLBAR_EVENTS.SHOW_CRM_TELEPHONE]: {
      name: AMEYO_TOOLBAR_EVENTS.SHOW_CRM_TELEPHONE,
      description: 'fetch the telephones of that lan'
    },
    [AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_AUTH_EVENT_INITIATED]: {
      name: AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_AUTH_EVENT_INITIATED,
      description: 'Ameyo Auth change inititated'
    },
    [AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_AUTH_EVENT_COMPLETED]: {
      name: AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_AUTH_EVENT_COMPLETED,
      description: 'Ameyo Auth change completed'
    },
    [AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_CONNECTION_EVENT_INITIATED]: {
      name: AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_CONNECTION_EVENT_INITIATED,
      description: 'Ameyo Connected change inititated'
    },
    [AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_CONNECTION_EVENT_COMPLETED]: {
      name: AMEYO_TOOLBAR_EVENTS.AMEYO_CHANGE_CONNECTION_EVENT_COMPLETED,
      description: 'Ameyo Connection change completed'
    },
    [AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS]: {
      name: AMEYO_TOOLBAR_EVENTS.AMEYO_GENERIC_EVENTS,
      description: 'Ameyo generic events'
    }
  });

export enum HRC_EVENTS {
  ACCEPT_CALL_MADE = 'HRC_ACCEPT_CALL_MADE',
  ACCEPT_CALL_RESPONSE = 'HRC_ACCEPT_CALL_RESPONSE',
  ACCEPT_CALL_FAILED = 'HRC_ACCEPT_CALL_FAILED',
  ACCEPT_BUTTON_CLICKED = 'HRC_ACCEPT_BUTTON_CLICKED',
  ACCEPT_EVENT_RECEIVED = 'HRC_ACCEPT_EVENT_RECEIVED',
  HRC_REJECT_BUTTON_CLICKED = 'HRC_REJECT_BUTTON_CLICKED',
  DISCONNECT_BUTTON_CLICKED = 'HRC_DISCONNECT_BUTTON_CLICKED',
  DISCONNECT_EVENT_RECEIVED = 'HRC_DISCONNECT_EVENT_RECEIVED',
  SUBMIT_API_CALLED = 'HRC_SUBMIT_API_CALLED',
  SUBMIT_API_RESPONSE = 'HRC_SUBMIT_API_RESPONSE',
  WAITING_LOADED = 'HRC_WAITING_LOADED',
  POPUP_SHOWN = 'HRC_POPUP_SHOWN',
  DASHBOARD_SHOWN = 'HRC_DASHBOARD_SHOWN',
  DASHBOARD_DETAILS_SHOWN = 'HRC_DASHBOARD_DETAILS_SHOWN',
  HRC_AMEYO_WINDOW_OPEN = 'HRC_AMEYO_WINDOW_OPEN',
  HRC_ACCEPT_CALL_MADE = 'HRC_ACCEPT_CALL_MADE',
  HRC_ACCEPT_CALL_RESPONSE = 'HRC_ACCEPT_CALL_RESPONSE',
  HRC_REJECT_SUCCESSFULL = 'HRC_REJECT_SUCCESSFULL',
  HRC_IMAGE_ZOOMED = 'HRC_IMAGE_ZOOMED',
  HRC_SUBMIT_FEEDBACK_CLICK = 'HRC_SUBMIT_FEEDBACK_CLICK',
  HRC_SUBMIT_FEEDBACK_FAILURE = 'HRC_SUBMIT_FEEDBACK_FAILURE',
  HRC_SUBMIT_FEEDBACK_SUCCESS = 'HRC_SUBMIT_FEEDBACK_SUCCESS',
  HRC_PAYMENT_SEND_LINK_CLICKED = 'HRC_PAYMENT_SEND_LINK_CLICKED',
  HRC_PAYMENT_SEND_LINK_SUCCESSFULL = 'HRC_PAYMENT_SEND_LINK_SUCCESSFULL',
  HRC_PAYMENT_SEND_LINK_FAILURE = 'HRC_PAYMENT_SEND_LINK_FAILURE',
  HRC_PAYMENT_SEND_LINK_AMOUNT_TYPE_CHANGED = 'HRC_PAYMENT_SEND_LINK_AMOUNT_TYPE_CHANGED',
  HRC_PAYMENT_SEND_LINK_AMOUNT_CHANGED = 'HRC_PAYMENT_SEND_LINK_AMOUNT_CHANGED',
  HRC_PAYMENT_SEND_LINK_ALTERNATE_NUMBER_CHANGED = 'HRC_PAYMENT_SEND_LINK_ALTERNATE_NUMBER_CHANGED',
  HRC_AMEYO_LOGIN_AUTO_SUCCESSFUL = 'HRC_AMEYO_LOGIN_AUTO_SUCCESSFUL',
  HRC_AMEYO_LOGIN_MANUAL_SUCCESSFUL = 'HRC_AMEYO_LOGIN_MANUAL_SUCCESSFUL',
  HRC_AMEYO_LOGIN_FAILURE = 'HRC_AMEYO_LOGIN_FAILURE',
  HRC_FEEDBACK_SELECTED = 'HRC_FEEDBACK_SELECTED',
  HRC_TOGGLE_AMEYO_CLICKED = 'HRC_TOGGLE_AMEYO_CLICKED',
  HRC_CALL_RINGING_EVENT = 'HRC_CALL_RINGING_EVENT',
  HRC_GENERIC_CLICKSTREAM = 'HRC_GENERIC_CLICKSTREAM',
  HRC_AMEYO_WINDOW_BACKGROUND_OPEN_ATTEMPT = 'HRC_AMEYO_WINDOW_BACKGROUND_OPEN_ATTEMPT',
  HRC_AMEYO_WINDOW_BACKGROUND_OPEN_SUCCESS = 'HRC_AMEYO_WINDOW_BACKGROUND_OPEN_SUCCESS',
  HRC_AMEYO_WINDOW_BACKGROUND_OPEN_FAILURE = 'HRC_AMEYO_WINDOW_BACKGROUND_OPEN_FAILURE',
  HRC_LOGIN_SUCCESSFUL = 'HRC_LOGIN_SUCCESSFUL',
  HRC_LOGOUT_CLICK = 'HRC_LOGOUT_CLICK',
  HRC_AUTO_ACCEPTED_CALL = 'HRC_AUTO_ACCEPTED_CALL',
  HRC_AMEYO_TOGGLE_MID_CALL_CLICK = 'HRC_AMEYO_TOGGLE_MID_CALL_CLICK',
  HRC_DISCONNECT_API_CALLED = 'HRC_DISCONNECT_API_CALLED',
  HRC_DISCONNECT_API_SUCCESS = 'HRC_DISCONNECT_API_SUCCESS',
  HRC_DISCONNECT_API_FAILURE = 'HRC_DISCONNECT_API_FAILURE',
  HRC_AMEYO_ERRONEOUS = 'HRC_AMEYO_ERRONEOUS',
  HRC_AMEYO_RELOADED = 'HRC_AMEYO_RELOADED',
  HRC_ACCEPT_CALL_TIMEOUT = 'HRC_ACCEPT_CALL_TIMEOUT',
  HRC_DISCONNECT_CALL_TIMEOUT = 'HRC_DISCONNECT_CALL_TIMEOUT',
  HRC_MISSED_CALL_SINCE_AGENT_IS_ON_CALL = 'HRC_MISSED_CALL_SINCE_AGENT_IS_ON_CALL'
}

export const HRC_CLICKSTREAM: Record<HRC_EVENTS, IClickStreamEvent> = {
  [HRC_EVENTS.HRC_ACCEPT_CALL_MADE]: {
    name: HRC_EVENTS.HRC_ACCEPT_CALL_MADE,
    description: 'accept endpoint is hit'
  },
  [HRC_EVENTS.HRC_ACCEPT_CALL_RESPONSE]: {
    name: HRC_EVENTS.HRC_ACCEPT_CALL_RESPONSE,
    description: 'got response from the accept api'
  },
  [HRC_EVENTS.ACCEPT_BUTTON_CLICKED]: {
    name: HRC_EVENTS.ACCEPT_BUTTON_CLICKED,
    description: 'accept button clicked'
  },
  [HRC_EVENTS.ACCEPT_EVENT_RECEIVED]: {
    name: HRC_EVENTS.ACCEPT_EVENT_RECEIVED,
    description: 'call is accepted from Ameyo window'
  },
  [HRC_EVENTS.HRC_REJECT_BUTTON_CLICKED]: {
    name: HRC_EVENTS.HRC_REJECT_BUTTON_CLICKED,
    description: 'reject button is clicked'
  },
  [HRC_EVENTS.DISCONNECT_BUTTON_CLICKED]: {
    name: HRC_EVENTS.DISCONNECT_BUTTON_CLICKED,
    description: 'disconnect button is clicked'
  },
  [HRC_EVENTS.DISCONNECT_EVENT_RECEIVED]: {
    name: HRC_EVENTS.DISCONNECT_EVENT_RECEIVED,
    description: 'disconnect event received'
  },
  [HRC_EVENTS.SUBMIT_API_CALLED]: {
    name: HRC_EVENTS.SUBMIT_API_CALLED,
    description: 'submit api is called'
  },
  [HRC_EVENTS.SUBMIT_API_RESPONSE]: {
    name: HRC_EVENTS.SUBMIT_API_RESPONSE,
    description: 'response of feedback submit api'
  },
  [HRC_EVENTS.WAITING_LOADED]: {
    name: HRC_EVENTS.WAITING_LOADED,
    description: 'is waiting screen loaded'
  },
  [HRC_EVENTS.POPUP_SHOWN]: {
    name: HRC_EVENTS.POPUP_SHOWN,
    description: 'is call incoming popup shown'
  },
  [HRC_EVENTS.DASHBOARD_SHOWN]: {
    name: HRC_EVENTS.DASHBOARD_SHOWN,
    description: 'when dashboard is show'
  },
  [HRC_EVENTS.DASHBOARD_DETAILS_SHOWN]: {
    name: HRC_EVENTS.DASHBOARD_DETAILS_SHOWN,
    description: 'when details of dashboard is loaded'
  },
  [HRC_EVENTS.HRC_AMEYO_WINDOW_OPEN]: {
    name: HRC_EVENTS.HRC_AMEYO_WINDOW_OPEN,
    description: 'ameyo window in opened'
  },
  [HRC_EVENTS.HRC_REJECT_SUCCESSFULL]: {
    name: HRC_EVENTS.HRC_REJECT_SUCCESSFULL,
    description: 'call got rejected successfully'
  },
  [HRC_EVENTS.HRC_IMAGE_ZOOMED]: {
    name: HRC_EVENTS.HRC_IMAGE_ZOOMED,
    description: 'HRC customer image is zoomed'
  },
  [HRC_EVENTS.HRC_SUBMIT_FEEDBACK_CLICK]: {
    name: HRC_EVENTS.HRC_SUBMIT_FEEDBACK_CLICK,
    description: 'HRC Submit feedback is clicked'
  },
  [HRC_EVENTS.HRC_SUBMIT_FEEDBACK_FAILURE]: {
    name: HRC_EVENTS.HRC_SUBMIT_FEEDBACK_FAILURE,
    description: 'HRC Submit feedback api failure'
  },
  [HRC_EVENTS.HRC_SUBMIT_FEEDBACK_SUCCESS]: {
    name: HRC_EVENTS.HRC_SUBMIT_FEEDBACK_SUCCESS,
    description: 'HRC Submit feedback api Success'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_CLICKED]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_CLICKED,
    description: 'HRC send payment link clicked'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_SUCCESSFULL]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_SUCCESSFULL,
    description: 'HRC send payment link sent successfully'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_FAILURE]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_FAILURE,
    description: 'HRC send payment link failed'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_AMOUNT_TYPE_CHANGED]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_AMOUNT_TYPE_CHANGED,
    description: 'HRC send payment link amount type changed'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_AMOUNT_CHANGED]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_AMOUNT_CHANGED,
    description: 'HRC send payment link amount changed'
  },
  [HRC_EVENTS.HRC_PAYMENT_SEND_LINK_ALTERNATE_NUMBER_CHANGED]: {
    name: HRC_EVENTS.HRC_PAYMENT_SEND_LINK_ALTERNATE_NUMBER_CHANGED,
    description: 'HRC send payment link alternate number changed'
  },
  [HRC_EVENTS.HRC_AMEYO_LOGIN_AUTO_SUCCESSFUL]: {
    name: HRC_EVENTS.HRC_AMEYO_LOGIN_AUTO_SUCCESSFUL,
    description: 'Ameyo autologin successful'
  },
  [HRC_EVENTS.HRC_AMEYO_LOGIN_MANUAL_SUCCESSFUL]: {
    name: HRC_EVENTS.HRC_AMEYO_LOGIN_MANUAL_SUCCESSFUL,
    description: 'Ameyo manual login successful'
  },
  [HRC_EVENTS.HRC_AMEYO_LOGIN_FAILURE]: {
    name: HRC_EVENTS.HRC_AMEYO_LOGIN_FAILURE,
    description: 'Ameyo login failure'
  },
  [HRC_EVENTS.ACCEPT_CALL_FAILED]: {
    name: HRC_EVENTS.ACCEPT_CALL_FAILED,
    description: 'Ameyo accept api call failed'
  },
  [HRC_EVENTS.HRC_FEEDBACK_SELECTED]: {
    name: HRC_EVENTS.HRC_FEEDBACK_SELECTED,
    description: 'Agent selects a feedback during/ after call'
  },
  [HRC_EVENTS.HRC_TOGGLE_AMEYO_CLICKED]: {
    name: HRC_EVENTS.HRC_TOGGLE_AMEYO_CLICKED,
    description: 'Agent clicks Ameyo Toggle in extension'
  },
  [HRC_EVENTS.HRC_CALL_RINGING_EVENT]: {
    name: HRC_EVENTS.HRC_CALL_RINGING_EVENT,
    description: 'Ameyo call ringing event'
  },
  [HRC_EVENTS.HRC_GENERIC_CLICKSTREAM]: {
    name: HRC_EVENTS.HRC_GENERIC_CLICKSTREAM,
    description: 'HRC Generic clickstream event'
  },
  [HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_SUCCESS]: {
    name: HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_SUCCESS,
    description: 'HRC ameyo window opened in background successfully'
  },
  [HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_ATTEMPT]: {
    name: HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_ATTEMPT,
    description: 'HRC attempted to open ameyo window in background'
  },
  [HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_FAILURE]: {
    name: HRC_EVENTS.HRC_AMEYO_WINDOW_BACKGROUND_OPEN_FAILURE,
    description: 'HRC failed to open ameyo window in background'
  },
  [HRC_EVENTS.HRC_LOGIN_SUCCESSFUL]: {
    name: HRC_EVENTS.HRC_LOGIN_SUCCESSFUL,
    description: 'Agent successfully logs in'
  },
  [HRC_EVENTS.HRC_LOGOUT_CLICK]: {
    name: HRC_EVENTS.HRC_LOGOUT_CLICK,
    description: 'Agent logs out of longhorn / Shut LH tab/ closes screen'
  },
  [HRC_EVENTS.HRC_AUTO_ACCEPTED_CALL]: {
    name: HRC_EVENTS.HRC_AUTO_ACCEPTED_CALL,
    description: 'HRC call gets auto accepted'
  },
  [HRC_EVENTS.HRC_AMEYO_TOGGLE_MID_CALL_CLICK]: {
    name: HRC_EVENTS.HRC_AMEYO_TOGGLE_MID_CALL_CLICK,
    description: 'HRC user click on extension toggle being currently on an active call'
  },
  [HRC_EVENTS.HRC_DISCONNECT_API_CALLED]: {
    name: HRC_EVENTS.HRC_DISCONNECT_API_CALLED,
    description: 'HRC disconnect api called'
  },
  [HRC_EVENTS.HRC_DISCONNECT_API_SUCCESS]: {
    name: HRC_EVENTS.HRC_DISCONNECT_API_SUCCESS,
    description: 'HRC disconnect api success'
  },
  [HRC_EVENTS.HRC_DISCONNECT_API_FAILURE]: {
    name: HRC_EVENTS.HRC_DISCONNECT_API_FAILURE,
    description: 'HRC disconnect api failure'
  },
  [HRC_EVENTS.HRC_AMEYO_ERRONEOUS]: {
    name: HRC_EVENTS.HRC_AMEYO_ERRONEOUS,
    description: 'HRC ameyo erroneous'
  },
  [HRC_EVENTS.HRC_AMEYO_RELOADED]: {
    name: HRC_EVENTS.HRC_AMEYO_RELOADED,
    description: 'HRC ameyo reloaded'
  },
  [HRC_EVENTS.HRC_ACCEPT_CALL_TIMEOUT]: {
    name: HRC_EVENTS.HRC_ACCEPT_CALL_TIMEOUT,
    description: 'HRC /accept api call request timed out'
  },
  [HRC_EVENTS.HRC_DISCONNECT_CALL_TIMEOUT]: {
    name: HRC_EVENTS.HRC_DISCONNECT_CALL_TIMEOUT,
    description: 'HRC /disconnect api call request timed out'
  },
  [HRC_EVENTS.HRC_MISSED_CALL_SINCE_AGENT_IS_ON_CALL]: {
    name: HRC_EVENTS.HRC_MISSED_CALL_SINCE_AGENT_IS_ON_CALL,
    description: 'Agent missed a call since he was on another call'
  }
};

export enum PERFORMANCE_DASHBOARD_EVENTS {
  LH_PERF_DASHBOARD_LOAD = 'LH_PERF_DASHBOARD_LOAD',
  LH_PERF_DASHBOARD_FILTER_CLICKED = 'LH_PERF_DASHBOARD_FILTER_CLICKED',
  LH_PERF_DASHBOARD_FILTER_OPTION_SELECTED = 'LH_PERF_DASHBOARD_FILTER_OPTION_SELECTED',
  LH_PERF_DASHBOARD_CLEAR_FILTER_CLICKED = 'LH_PERF_DASHBOARD_CLEAR_FILTER_CLICKED',
  LH_AGENT_TRACKING_CLICKED = 'LH_AGENT_TRACKING_CLICKED'
}

export const PERFORMANCE_DASHBOARD_CLICKSTREAM: Record<
  PERFORMANCE_DASHBOARD_EVENTS,
  IClickStreamEvent
> = {
  [PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_LOAD]: {
    name: PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_LOAD,
    description: 'To be triggered when the AM perf dashboard is loaded'
  },
  [PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_FILTER_CLICKED]: {
    name: PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_FILTER_CLICKED,
    description: 'To be triggered when filter is clicked'
  },
  [PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_FILTER_OPTION_SELECTED]: {
    name: PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_FILTER_OPTION_SELECTED,
    description: 'To be triggered when filter option is clicked'
  },
  [PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_CLEAR_FILTER_CLICKED]: {
    name: PERFORMANCE_DASHBOARD_EVENTS.LH_PERF_DASHBOARD_CLEAR_FILTER_CLICKED,
    description: 'To be triggered when clear filter is clicked'
  },
  [PERFORMANCE_DASHBOARD_EVENTS.LH_AGENT_TRACKING_CLICKED]: {
    name: PERFORMANCE_DASHBOARD_EVENTS.LH_AGENT_TRACKING_CLICKED,
    description: 'To be triggered when agent tracking is clicked'
  }
};

export const AMEYO_SESSION_EVENTS = {
  LH_AMEYO_FETCH_CONNECTED_CUSTOMER_FAILED: {
    name: 'LH_AMEYO_FETCH_CONNECTED_CUSTOMER_FAILED',
    description: 'unable to fetch connected customer data'
  },
  LH_AMEYO_CREATE_INTERACTION_FAILED: {
    name: 'LH_AMEYO_CREATE_INTERACTION_FAILED',
    description: 'Unable to create interaction'
  },
  LH_AMEYO_SUCCESSFUL_LOGIN: {
    name: 'LH_AMEYO_SUCCESSFUL_LOGIN',
    description: 'User successfully logs in to ameyo '
  },
  LH_AMEYO_AVAILABLE_TOGGLE_CLICKED: {
    name: 'LH_AMEYO_AVAILABLE_TOGGLE_CLICKED',
    description: 'User clicked the ameyo toggle'
  },
  LH_AMEYO_AVAILABLE_TOGGLE_ON_SUCCESSFULLY: {
    name: 'LH_AMEYO_AVAILABLE_TOGGLE_ON_SUCCESSFULLY',
    description: 'User turns the ameyo toggle on successfully'
  },
  LH_AMEYO_AVAILABLE_TOGGLE_OFF_SUCCESSFULLY: {
    name: 'LH_AMEYO_AVAILABLE_TOGGLE_OFF_SUCCESSFULLY',
    description: 'User turns the ameyo toggle off successfully'
  },
  LH_AMEYO_SUCCESSFUL_LOGOUT: {
    name: 'LH_AMEYO_SUCCESSFUL_LOGOUT',
    description: 'User logs out of ameyo'
  },
  LH_AMEYO_CALL_ACCEPT_CLICKED: {
    name: 'LH_AMEYO_CALL_ACCEPT_CLICKED',
    description: 'User clicks accept for a call'
  },
  LH_AMEYO_CALL_ACCEPTED_SUCCESSFULLY: {
    name: 'LH_AMEYO_CALL_ACCEPTED_SUCCESSFULLY',
    description: 'Call got accepted successfully'
  },
  LH_AMEYO_CALL_REJECT_CLICKED: {
    name: 'LH_AMEYO_CALL_REJECT_CLICKED',
    description: 'User clicks reject for a call'
  },
  LH_AMEYO_CALL_REJECTED_SUCCESSFULLY: {
    name: 'LH_AMEYO_CALL_REJECTED_SUCCESSFULLY',
    description: 'Call got rejected successfully '
  },
  LH_AMEYO_CALL_DISCONNECT_CLICKED: {
    name: 'LH_AMEYO_CALL_DISCONNECT_CLICKED',
    description: 'Call got disconnected successfully '
  },
  LH_AMEYO_CALL_DISCONNECTED_SUCCESSFULLY: {
    name: 'LH_AMEYO_CALL_DISCONNECTED_SUCCESSFULLY',
    description: 'Call got disconnected successfully '
  },
  LH_AMEYO_MUTE_WIDGET_CLICKED: {
    name: 'LH_AMEYO_MUTE_WIDGET_CLICKED',
    description: 'Agent clicked on mute in ameyo widget'
  },
  LH_AMEYO_MUTE_TOOLBAR_CLICKED: {
    name: 'LH_AMEYO_MUTE_TOOLBAR_CLICKED',
    description: 'Agent clicked on mute in toolbar'
  },
  LH_AMEYO_MUTE_SHORTCUT_CLICKED: {
    name: 'LH_AMEYO_MUTE_SHORTCUT_CLICKED',
    description: 'Agent clicked on ctrl+m to mute the call'
  },
  LH_AMEYO_UNMUTE_WIDGET_CLICKED: {
    name: 'LH_AMEYO_UNMUTE_WIDGET_CLICKED',
    description: 'Agent clicked on unmute in ameyo widget'
  },
  LH_AMEYO_UNMUTE_TOOLBAR_CLICKED: {
    name: 'LH_AMEYO_UNMUTE_TOOLBAR_CLICKED',
    description: 'Agent clicked on unmute in toolbar'
  },
  LH_AMEYO_UNMUTE_SHORTCUT_CLICKED: {
    name: 'LH_AMEYO_UNMUTE_SHORTCUT_CLICKED',
    description: 'Agent clicked on ctrl+m to unmute the call'
  },
  LH_AMEYO_MUTE_SUCCESSFULL: {
    name: 'LH_AMEYO_MUTE_SUCCESSFULL',
    description: 'Call muted successfully'
  },
  LH_AMEYO_UNMUTE_SUCCESSFULL: {
    name: 'LH_AMEYO_UNMUTE_SUCCESSFULL',
    description: 'Call unmutted successfully'
  },
  LH_AMEYO_DISCONNECT_TOOLBAR_CLICKED: {
    name: 'LH_AMEYO_DISCONNECT_TOOLBAR_CLICKED',
    description: 'Agent clicked on disconnect in toolbar'
  },
  LH_AMEYO_UNMUTE_ERROR: {
    name: 'LH_AMEYO_UNMUTE_ERROR',
    description: 'Agent unable to unmute the call due to ameyo extension error'
  },
  LH_AMEYO_MUTE_ERROR: {
    name: 'LH_AMEYO_MUTE_ERROR',
    description: 'Agent unable to mute the call due to ameyo extension error'
  },
  LH_AMEYO_DISCONNECT_ERROR: {
    name: 'LH_AMEYO_DISCONNECT_ERROR',
    description: 'Agent unable to end the call due to ameyo extension error'
  },
  LH_AMEYO_REJECT_ERROR: {
    name: 'LH_AMEYO_REJECT_ERROR',
    description: 'Agent unable to reject the call due to ameyo extension error'
  },
  LH_AMEYO_ACCEPT_ERROR: {
    name: 'LH_AMEYO_ACCEPT_ERROR',
    description: 'Agent unable to accept the call due to ameyo extension error'
  },
  LH_AMEYO_USER_AVAILABILITY: {
    name: 'LH_AMEYO_USER_AVAILABILITY',
    description: 'Agent active/inactive status every 30 seconds.'
  },
  LH_AMEYO_PAGE_UNLOAD: {
    name: 'LH_AMEYO_PAGE_UNLOAD',
    description: 'Ameyo page unloads or becomes unresponsive'
  },
  LH_AMEYO_PAGE_LOADED: {
    name: 'LH_AMEYO_PAGE_LOADED',
    description: 'Ameyo page loads successfully'
  },
  LH_AMEYO_RINGING: {
    name: 'LH_AMEYO_RINGING',
    description: 'Incoming call'
  },
  LH_AMEYO_EXTENSION_TOGGLE_ON_CLICKED: {
    name: 'LH_AMEYO_EXTENSION_TOGGLE_ON_CLICKED',
    description: 'When extension toggle is off and user clicks on it to turn it on.'
  },
  LH_AMEYO_EXTENSION_TOGGLE_OFF_CLICKED: {
    name: 'LH_AMEYO_EXTENSION_TOGGLE_OFF_CLICKED',
    description: 'When extension toggle is on and user clicks on it to turn it off.'
  },
  LH_AMEYO_LOGIN_AUTO_SUCCESSFUL: {
    name: 'LH_AMEYO_LOGIN_AUTO_SUCCESSFUL',
    description: 'Ameyo autologin successful'
  },
  LH_AMEYO_ERRONEOUS: {
    name: 'LH_AMEYO_ERRONEOUS',
    description: 'Ameyo erroneous'
  },
  LH_AMEYO_EXTENSION_TOGGEL_ON_SUCCESSFULL: {
    name: 'LH_AMEYO_EXTENSION_TOGGEL_ON_SUCCESSFULL',
    description: 'Ameyo extension toggle on successful'
  },
  LH_AMEYO_EXTENSION_TOGGEL_OFF_SUCCESSFULL: {
    name: 'LH_AMEYO_EXTENSION_TOGGEL_OFF_SUCCESSFULL',
    description: 'Ameyo extension toggle off successful'
  },
  LH_AMEYO_FORCED_LOGOUT: {
    name: 'LH_AMEYO_FORCED_LOGOUT',
    description: 'Ameyo forced logout'
  }
};

export const AgentTrackingEvents = {
  LH_AGENT_TRACKING_PAGE_LOAD: {
    name: 'LH_AGENT_TRACKING_PAGE_LOAD',
    description: 'Agent tracking page load'
  },
  LH_AGENT_TRACKING_PIN_CLICKED: {
    name: 'LH_AGENT_TRACKING_PIN_CLICKED',
    description: 'Agent tracking pin clicked'
  },
  LH_AGENT_TRACKING_VIEW_ALL_CLICKED: {
    name: 'LH_AGENT_TRACKING_VIEW_ALL_CLICKED',
    description: 'Agent tracking view all clicked'
  },
  LH_AGENT_TRACKING_ZOOM_IN_CLICKED: {
    name: 'LH_AGENT_TRACKING_ZOOM_IN_CLICKED',
    description: 'Agent tracking zoom in clicked'
  },
  LH_AGENT_TRACKING_ZOOM_OUT_CLICKED: {
    name: 'LH_AGENT_TRACKING_ZOOM_OUT_CLICKED',
    description: 'Agent tracking zoom out clicked'
  },
  LH_AGENT_TRACKING_DEFAULT_VIEW_CLICKED: {
    name: 'LH_AGENT_TRACKING_DEFAULT_VIEW_CLICKED',
    description: 'Agent tracking default view clicked'
  },
  LH_AGENT_TRACKING_FILTER_SELECTED: {
    name: 'LH_AGENT_TRACKING_FILTER_SELECTED',
    description: 'Agent tracking filter selected'
  },
  LH_AGENT_TRACKING_CLEAR_FILTER_CLICKED: {
    name: 'LH_AGENT_TRACKING_CLEAR_FILTER_CLICKED',
    description: 'Agent tracking clear filter clicked'
  },
  LH_MAP_AGENT_DROPDOWN_CLICKED: {
    name: 'LH_MAP_AGENT_DROPDOWN_CLICKED',
    description: 'Map agent dropdown clicked'
  },
  LH_MAP_AGENT_CLICKED: {
    name: 'LH_MAP_AGENT_CLICKED',
    description: 'Map agent clicked'
  },
  LH_MAP_FILTER_CLICKED: {
    name: 'LH_MAP_FILTER_CLICKED',
    description: 'Map filter clicked'
  },
  LH_MAP_FEEDBACK_CLICKED: {
    name: 'LH_MAP_FEEDBACK_CLICKED',
    description: 'Map feedback clicked'
  },
  LH_MAP_FEEDBACK_DOUBLE_CLICKED: {
    name: 'LH_MAP_FEEDBACK_DOUBLE_CLICKED',
    description: 'Map feedback double clicked'
  },
  LH_MAP_OPEN_CASE_CLICKED: {
    name: 'LH_MAP_OPEN_CASE_CLICKED',
    description: 'Map open case clicked'
  },
  LH_MAP_DATE_FILTER_CLICKED: {
    name: 'LH_MAP_DATE_FILTER_CLICKED',
    description: 'Map date filter clicked'
  },
  LH_MAP_DATE_FILTER_APPLIED: {
    name: 'LH_MAP_DATE_FILTER_APPLIED',
    description: 'Map date filter applied'
  },
  LH_MAP_AGENT_VIEW_BACK_CLICKED: {
    name: 'LH_MAP_AGENT_VIEW_BACK_CLICKED',
    description: 'Map agent view back clicked'
  },
  LH_MAP_AGENT_VIEW_PIN_CLICKED: {
    name: 'LH_MAP_AGENT_VIEW_PIN_CLICKED',
    description: 'Map agent view pin clicked'
  },
  LH_MAP_FILTER_APPLIED: {
    name: 'LH_LLOCATION_VIEW_FILTER_APPLIED',
    description: 'Map view filter applied'
  },
  LH_MAP_AUTOCOMPLETE_FILTER_APPLIED: {
    name: 'LH_MAP_AUTOCOMPLETE_FILTER_APPLIED',
    description: 'Map view autocomplete filter applied'
  },
  LH_MAP_SEARCH: {
    name: 'LH_MAP_SEARCH',
    description: 'Map view search'
  },
  LH_MAP_AGENT_REDIRECTION_ICON_CLICKED: {
    name: 'LH_MAP_AGENT_REDIRECTION_CLICKED',
    description: 'Map agent redirection icon clicked'
  },
  LH_COSMOS_SYNC_AGENT_BLOCKED: {
    name: 'LH_COSMOS_SYNC_AGENT_BLOCKED',
    description: 'Agent blocked due to failure of cosmos sync'
  },
  LH_COSMOS_SYNC_WARNING_MODAL_LOADED: {
    name: 'LH_COSMOS_SYNC_WARNING_MODAL_LOADED',
    description: 'Cosmos sync warning modal appeared'
  },
  LH_COSMOS_SYNC_WARNING_CTA_BUTTON_CLICKED: {
    name: 'LH_COSMOS_SYNC_WARNING_CTA_CLICKED',
    description: 'Agent clicked on the CTA in the cosmos sync warning modal'
  },
  LH_RISK_MANAGEMENT_LOADED: {
    name: 'LH_RISK_MANAGEMENT_LOADED',
    description: 'Risk management loaded'
  },
  LH_RISK_MANAGEMENT_ESCALATION_VIEW_MORE: {
    name: 'LH_RISK_MANAGEMENT_ESCALATION_VIEW_MORE',
    description: 'Risk management escalation view more clicked'
  }
};

export const CASE_TABLE_FILTERS = {
  [CaseFilter.assignedAtFilters]: {
    name: 'LH_Filter_DateOfAllocation',
    description: 'Click on Case Type option on Filter'
  },
  [CaseFilter.dpdDuringAllocationFilters]: {
    name: 'LH_Filter_CaseType',
    description: 'Click on Case Type option on Filter'
  },
  [CaseFilter.paymentStatus]: {
    name: 'LH_Filter_PaymentStatus',
    description: 'Click on Payment Status option on Filter'
  },
  [CaseFilter.interactionStatuses]: {
    name: 'LH_Filter_InteractionStatus',
    description: 'Click on Interaction Status option on Filter'
  },
  [CaseFilter.riskSegments]: {
    name: 'LH_Filter_RiskFilters',
    description: 'Click on Customer Risk option on Filter'
  },
  [CaseFilter.ptpStatus]: {
    name: 'LH_Filter_PTPStatus',
    description: 'Click on PTP Status option on Filter'
  },
  [CaseFilter.callBackToday]: {
    name: 'LH_Filter_CallBackToday',
    description: 'Click on Call Back Today option on Filter'
  },
  [CaseFilter.callCoverage]: {
    name: 'LH_Filter_CallCoverage',
    description: 'Click on Call Coverage option on Filter'
  }
};

export const FEE_WAIVER_CLICKSTREAM = {
  LH_WAIVE_BUTTON_CLICKED: {
    name: 'LH_WAIVE_BUTTON_CLICKED',
    description: 'LH_WAIVE_BUTTON_CLICKED'
  },
  LH_WAIVE_HISTORY_BUTTON_CLICKED: {
    name: 'LH_WAIVE_HISTORY_BUTTON_CLICKED',
    description: 'LH_WAIVE_HISTORY_BUTTON_CLICKED'
  },
  LH_WAIVE_DRAWER_LOADED: {
    name: 'LH_WAIVE_DRAWER_LOADED',
    description: 'LH_WAIVE_DRAWER_LOADED'
  },
  LH_WAIVE_SUBMIT_CLICKED: {
    name: 'LH_WAIVE_SUBMIT_CLICKED',
    description: 'LH_WAIVE_SUBMIT_CLICKED'
  },
  LH_WAIVE_SUCCESSFULLY_DONE: {
    name: 'LH_WAIVE_SUCCESSFULLY_DONE',
    description: 'LH_WAIVE_SUCCESSFULLY_DONE'
  },
  LH_WAIVE_PROMPT_LOADED: {
    name: 'LH_WAIVE_PROMPT_LOADED',
    description: 'LH_WAIVE_PROMPT_LOADED'
  },
  LH_WAIVE_CONFIRM_CLICKED: {
    name: 'LH_WAIVE_CONFIRM_CLICKED',
    description: 'LH_WAIVE_CONFIRM_CLICKED'
  },
  LH_EMI_BREAKUP_LOADED: {
    name: 'LH_EMI_BREAKUP_LOADED',
    description: 'LH_EMI_BREAKUP_LOADED'
  },
  LH_WAIVE_HISTORY_LOADED: {
    name: 'LH_WAIVE_HISTORY_LOADED',
    description: 'LH_WAIVE_HISTORY_LOADED'
  }
};

export const ErrorBoundaryEvents = {
  FRONT_END_ERROR: {
    name: 'FRONT_END_ERROR',
    description: 'Front end error'
  }
};

export const ENACH_CLICKSTREAM = {
  LH_SIDEPANEL_ENACH_ICON_CLICKED: {
    name: 'LH_ENACH_ICON_CLICKED',
    description: 'When enach icon is clicked'
  },
  LH_VIEW_ENACH_UPLOAD_HISTORY_CLICKED: {
    name: 'LH_VIEW_ENACH_UPLOAD_HISTORY_CLICKED',
    description: 'When View Upload History is clicked on E-NACH tab'
  },
  LH_DOWNLOAD_SAMPLE_FILE_ENACH: {
    name: 'LH_DOWNLOAD_SAMPLE_FILE_ENACH',
    description: 'When user downloads Sample file on E-NACH tab'
  },
  LH_ENACH_TRIGGER_FILE_UPLOAD_ATTEMPT: {
    name: 'LH_ENACH_TRIGGER_FILE_UPLOAD_ATTEMPT',
    description: 'When a file upload attempt is made'
  },
  LH_ENACH_TRIGGER_FILE_UPLOAD_SUCCESSFUL: {
    name: 'LH_ENACH_TRIGGER_FILE_UPLOAD_SUCCESSFUL',
    description: 'When a file is uploaded successfully'
  },
  LH_ENACH_TRIGGER_FILE_UPLOAD_FAILED: {
    name: 'LH_ENACH_TRIGGER_FILE_UPLOAD_FAILED',
    description: 'When file upload fails'
  },
  LH_ENACH_TRIGGER_FILE_SUBMITTED: {
    name: 'LH_ENACH_TRIGGER_FILE_SUBMITTED',
    description: 'When a enach trigger attempt is made by clicking on submit button'
  },
  LH_ENACH_TRIGGER_TYPE_SELECTED: {
    name: 'LH_ENACH_TRIGGER_TYPE_SELECTED',
    description: 'When the type of e-nach is selected'
  },
  LH_ENACH_FILE_SUBMISSION_SUCCESSFUL: {
    name: 'LH_ENACH_FILE_SUBMISSION_SUCCESSFUL',
    description: 'When a file is submitted successfully'
  },
  LH_ENACH_FILE_SUBMISSION_FAILED: {
    name: 'LH_ENACH_FILE_SUBMISSION_FAILED',
    description: 'When file submission fails'
  }
};

export const AGENT_LOGOUT_CLICK = {
  LH_DOCUMENT_DOWNLOAD_CLICKED: {
    name: 'LH_DOCUMENT_DOWNLOAD_CLICKED',
    description: 'LH_DOCUMENT_DOWNLOAD_CLICKED'
  }
};

export const FDM_DASHBOARD_CLICKSTREAM = {
  LH_FDM_OVERALL_METRIC_PAGE_LOADED: {
    name: 'LH_FDM_OVERALL_METRIC_PAGE_LOADED',
    description: 'LH_FDM_OVERALL_METRIC_PAGE_LOADED'
  },
  LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_APPLIED: {
    name: 'LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_APPLIED',
    description: 'LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_APPLIED'
  },
  LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_REMOVED: {
    name: 'LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_REMOVED',
    description: 'LH_FDM_OVERALL_METRIC_TEAM_LEAD_FILTER_REMOVED'
  },
  LH_FDM_OVERALL_METRIC_BUCKET_FILTER_APPLIED: {
    name: 'LH_FDM_OVERALL_METRIC_BUCKET_SELECTED',
    description: 'LH_FDM_OVERALL_METRIC_BUCKET_SELECTED'
  },
  LH_FDM_OVERALL_METRIC_BUCKET_FILTER_REMOVED: {
    name: 'LH_FDM_OVERALL_METRIC_BUCKET_REMOVED',
    description: 'LH_FDM_OVERALL_METRIC_BUCKET_REMOVED'
  },
  LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLICKED: {
    name: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLICKED',
    description: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLICKED'
  },
  LH_FDM_OVERALL_METRIC_AGENT_DETAILS_LOADED: {
    name: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_LOADED',
    description: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_LOADED'
  },
  LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLOSED: {
    name: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLOSED',
    description: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_CLOSED'
  },
  LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_OPENED: {
    name: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_OPENED',
    description: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_OPENED'
  },
  LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_CLOSED: {
    name: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_CLOSED',
    description: 'LH_FDM_OVERALL_METRIC_AGENT_DETAILS_ACCORDION_CLOSED'
  }
};

export const AGENCY_CAPPING_CLICKSTREAM = {
  LH_CLICK_AGENCY_OPERATIONS_TAB: {
    name: 'LH_CLICK_AGENCY_OPERATIONS_TAB',
    description: 'Clicked Agency Operations tab on Longhorn'
  },
  LH_CLICK_PINCODE_MAPPING_TAB: {
    name: 'LH_CLICK_PINCODE_MAPPING_TAB',
    description: 'Clicked Pincode Mapping tab on Agency Operations'
  },
  LH_CLICK_AGENCY_CAPPING_TAB: {
    name: 'LH_CLICK_AGENCY_CAPPING_TAB',
    description: 'Clicked Agency Capping tab on Agency Operations'
  },
  LH_CLICK_DOWNLOAD_CURRENT_CAPPING_BUTTON: {
    name: 'LH_CLICK_DOWNLOAD_CURRENT_CAPPING_BUTTON',
    description: 'Clicked Download Current Capping button on Agency Capping tab'
  },
  LH_CLICK_UPDATE_AGENCY_CAPPING_BUTTON: {
    name: 'LH_CLICK_UPDATE_AGENCY_CAPPING_BUTTON',
    description: 'Clicked Update Agency Capping button on Agency Capping tab'
  },
  LH_CLICK_SELECT_AGENCY_DROPDOWN_AGENCY_CAPPING: {
    name: 'LH_CLICK_SELECT_AGENCY_DROPDOWN_AGENCY_CAPPING',
    description: 'Clicked Select Agency dropdown on Agency Capping tab'
  },
  LH_CLICK_FILTER_STATE_DROPDOWN_AGENCY_CAPPING: {
    name: 'LH_CLICK_FILTER_STATE_DROPDOWN_AGENCY_CAPPING',
    description: 'Clicked Filter State dropdown on Agency Capping tab'
  },
  LH_SELECT_AGENCY_FROM_DROPDOWN_AGENCY_CAPPING: {
    name: 'LH_SELECT_AGENCY_FROM_DROPDOWN_AGENCY_CAPPING',
    description: 'Selected agency from Select Agency dropdown on Agency Capping tab'
  },
  LH_SELECT_STATE_FROM_DROPDOWN_AGENCY_CAPPING: {
    name: 'LH_SELECT_STATE_FROM_DROPDOWN_AGENCY_CAPPING',
    description: 'Selected state from Filter State dropdown on Agency Capping tab'
  },
  LH_ATTEMPT_UPLOAD_FILE_UPDATE_CAPPING: {
    name: 'LH_ATTEMPT_UPLOAD_FILE_UPDATE_CAPPING',
    description: 'Attempted upload file on Update Agency Capping drawer'
  },
  LH_SUCCESS_UPLOAD_FILE_UPDATE_CAPPING: {
    name: 'LH_SUCCESS_UPLOAD_FILE_UPDATE_CAPPING',
    description: 'Successfully uploaded file on Update Agency Capping drawer'
  },
  LH_CLICK_SUBMIT_BUTTON_UPDATE_CAPPING: {
    name: 'LH_CLICK_SUBMIT_BUTTON_UPDATE_CAPPING',
    description: 'Clicked Submit button on Update Agency Capping drawer'
  },
  LH_SUCCESS_FILE_SUBMISSION_UPDATE_CAPPING: {
    name: 'LH_SUCCESS_FILE_SUBMISSION_UPDATE_CAPPING',
    description: 'Successfully submitted file on Update Agency Capping drawer'
  },
  LH_FAILURE_FILE_SUBMISSION_UPDATE_CAPPING: {
    name: 'LH_FAILURE_FILE_SUBMISSION_UPDATE_CAPPING',
    description: 'Failed to submit file on Update Agency Capping drawer'
  }
};

export const SELF_SERVE_UI_CLICKSTREAM = {
  LH_INITIATE_MOCK_CLICKED: {
    name: 'click_initiate_mock',
    description: 'User clicks Initiate mock'
  },
  LH_MOCK_RUN_CARD_CLICKED: {
    name: 'click_mock_run_card',
    description: 'User clicks on a mock run card'
  },
  LH_DOWNLOAD_INHOUSE_FILE_CLICKED: {
    name: 'click_download_inhouse_file',
    description: 'User clicks Inhouse download link (Input section)'
  },
  LH_DOWNLOAD_AGENCY_FILE_CLICKED: {
    name: 'click_download_agency_file',
    description: 'User clicks Agency download link (Input section)'
  },
  LH_PREVIOUS_ALLOCATION_CLICKED: {
    name: 'click_previous_allocation',
    description: 'User clicks Previous allocation'
  },
  LH_LIVE_VALIDATIONS_CLICKED: {
    name: 'click_live_validations',
    description: 'User clicks Live validations button'
  },
  LH_TRIGGER_MOCK_CLICKED: {
    name: 'click_trigger_mock',
    description: 'User clicks Trigger mock button'
  },
  LH_ERROR_REPORT_AGENCY_CLICKED: {
    name: 'click_error_report_agency',
    description: 'User clicks Error report under Agency Output validations'
  },
  LH_ERROR_REPORT_INHOUSE_CLICKED: {
    name: 'click_error_report_inhouse',
    description: 'User clicks Error report under Inhouse Output validations'
  },
  LH_DOWNLOAD_POST_ALLOCATION_REPORT_CLICKED: {
    name: 'click_download_post_allocation_report',
    description: 'User clicks Download in Post allocation failure report section'
  },
  LH_APPROVE_MOCK_CLICKED: {
    name: 'click_approve_mock',
    description: 'User clicks the Approve mock button'
  },
  LH_DOWNLOAD_INHOUSE_OUTPUT_CLICKED: {
    name: 'click_download_inhouse_output',
    description: 'User clicks Inhouse Output download link'
  },
  LH_DOWNLOAD_AGENCY_OUTPUT_CLICKED: {
    name: 'click_download_agency_output',
    description: 'User clicks Agency Output download link'
  },
  LH_AGENCY_CAPPING_TOGGLE_CLICKED: {
    name: 'click_agency_capping_toggle',
    description: 'User toggles between Included and Excluded for agency capping'
  }
};

export const VISIT_PLAN_CLICKSTREAM = {
  LH_VISIT_PLAN_VIEW: {
    name: 'Visit_plan_view',
    description: 'Visit plan view'
  },
  LH_VISIT_PLAN_ALL_CASES_VIEW: {
    name: 'Visit_plan_All_Cases_view',
    description: 'All Cases view in Visit Plan'
  },
  LH_VISIT_PLAN_ADD_CASES_CLICK: {
    name: 'Visit_plan_add_cases_click',
    description: 'Add cases button clicked in Visit Plan'
  },
  LH_DATE_TAB_CLICK: {
    name: 'date_tab_click',
    description: 'Date tab clicked'
  },
  LH_DATE_SELECTION_CLICK: {
    name: 'date_selection_click',
    description: 'Date selection clicked'
  },
  LH_VISIT_PLAN_TAB_CLICK: {
    name: 'Visit_plan_tab_click',
    description: 'Visit Plan tab clicked'
  },
  LH_VISIT_PLAN_AGENCY_CLICK: {
    name: 'Visit_plan_agency_click',
    description: 'Agency selection clicked in Visit Plan'
  },
  LH_VISIT_PLAN_AGENT_CLICK: {
    name: 'Visit_plan_agent_click',
    description: 'Agent selection clicked in Visit Plan'
  },
  LH_VISIT_PLAN_ALL_CASES_CASE_SELECTION: {
    name: 'Visit_plan_all_cases_case_selection',
    description: 'Case selection in All Cases view'
  },
  LH_VISIT_PLAN_ALL_CASES_ADD_ADDRESS_CLICK: {
    name: 'Visit_plan_all_cases_add_address_click',
    description: 'Add address button clicked in All Cases'
  },
  LH_VISIT_PLAN_ALL_CASES_VIEW_ALL_ADDRESS_CLICK: {
    name: 'Visit_plan_all_cases_view_all_address_click',
    description: 'View all addresses button clicked in All Cases'
  },
  LH_VISIT_PLAN_MAP_VIEW_CLICK_TO_SELECT: {
    name: 'Visit_plan_map_view_click_to_select',
    description: 'Map view click to select location'
  },
  LH_VISIT_PLAN_MAP_VIEW_CLICK_TO_ADD_ADDRESS: {
    name: 'Visit_plan_map_view_click_to_add_address',
    description: 'Map view click to add address'
  },
  LH_VISIT_PLAN_MAP_VIEW_ADD_ADDRESS_CLICK: {
    name: 'Visit_plan_map_view_add_address_click',
    description: 'Add address button clicked in Map view'
  },
  LH_VISIT_PLAN_FILTER_TAB_CLICK: {
    name: 'Visit_plan_Filter_tab_click',
    description: 'Filter tab clicked in Visit Plan'
  },
  LH_VISIT_PLAN_ADDRESS_RANK_FILTER_CLICK: {
    name: 'Visit_plan_Address_Rank_Filter_click',
    description: 'Address Rank Filter clicked'
  },
  LH_VISIT_PLAN_FILTER_SELECTION_CLICK: {
    name: 'Visit_plan_Filter_selection_click',
    description: 'Filter selection clicked'
  },
  LH_VISIT_PLAN_FILTER_SELECTION_OPTION_CLICK: {
    name: 'Visit_plan_Filter_selection_option_click',
    description: 'Filter selection option clicked'
  },
  LH_VISIT_PLAN_SEARCH_OPTION_CLICK: {
    name: 'Visit_plan_search_option_click',
    description: 'Search option clicked'
  },
  LH_VISIT_PLAN_SEARCH_PERFORM_CLICK: {
    name: 'Visit_plan_search_perform_click',
    description: 'Search perform button clicked'
  },
  LH_VISIT_PLAN_ALL_CASES_CONFIRM_CLICK: {
    name: 'Visit_plan_all_cases_confirm_click',
    description: 'Confirm button clicked in All Cases'
  },
  LH_VISIT_PLAN_CONFIRM_CLICK: {
    name: 'Visit_plan_confirm_click',
    description: 'Confirm button clicked in Visit Plan'
  },
  LH_VISIT_PLAN_CLEAR_ALL_CLICK: {
    name: 'Visit_plan_clear_all_click',
    description: 'Clear all button clicked in Visit Plan'
  },
  LH_VISIT_PLAN_REMOVE_CASE: {
    name: 'Visit_plan_remove_case',
    description: 'Remove case from Visit Plan'
  },
  LH_VISIT_PLAN_ERROR: {
    name: 'Visit_plan_error',
    description: 'Error occurred in Visit Plan'
  },
  LH_VISIT_PLAN_PROFILE_CLICK: {
    name: 'Visit_plan_profile_click',
    description: 'Profile clicked in Visit Plan'
  },
  LH_VISIT_PLAN_TAG_CLICK: {
    name: 'Visit_plan_tag_click',
    description: 'Tag clicked in Visit Plan'
  },
  LH_VISIT_PLAN_UNSAVED_CHANGES_VIEW: {
    name: 'Visit_plan_unsaved_changes_view',
    description: 'Unsaved changes view displayed'
  },
  LH_VISIT_PLAN_UNSAVED_CHANGES_CANCEL: {
    name: 'Visit_plan_unsaved_changes_cancel',
    description: 'Unsaved changes cancel clicked'
  },
  LH_VISIT_PLAN_UNSAVED_CHANGES_CONFIRM: {
    name: 'Visit_plan_unsaved_changes_confirm',
    description: 'Unsaved changes confirm clicked'
  },
  LH_VISIT_PLAN_ADD_TO_TODAY_VISIT_PLAN: {
    name: 'Visit_plan_add_to_today_visit_plan',
    description: "Add to today's visit plan"
  },
  LH_VISIT_PLAN_ADD_TO_TOMORROW_VISIT_PLAN: {
    name: 'Visit_plan_add_to_tomorrow_visit_plan',
    description: "Add to tomorrow's visit plan"
  }
};
